<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>{{ title }}</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'dataInformasi' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-overlay
                :show="isShowData"
                variant="light"
                opacity="0.85"
                blur="2px"
                rounded="sm"
              >
                <b-form-group
                  label="Kode Lokasi"
                  label-for="kodeLokasi"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="kodeLokasi"
                    v-model="kolokVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="KIB"
                  label-for="kib"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="kib"
                    v-model="kibVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Kode Barang"
                  label-for="kodeBarang"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="kodeBarang"
                    v-model="kobarVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Nama Barang"
                  label-for="namaBarang"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="namaBarang"
                    v-model="nabarVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Kode Register Barang"
                  label-for="kodeRegisterBarang"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="kodeRegisterBarang"
                    v-model="kodeRegisterBarangVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Nilai Perolehan"
                  label-for="nilaiPerolehan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="nilaiPerolehan"
                    v-model="nilaiPerolehanVal"
                    disabled
                  />
                </b-form-group>

                <b-form-group
                  label="Tanggal Perolehan"
                  label-for="tahunPerolehan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-input
                    id="tahunPerolehan"
                    v-model="tahunPerolehanVal"
                    disabled
                  />
                </b-form-group>

                <!-- no1 -->
                <V1KodeBarang
                  :kesesuaian-kode-barang-val="v$.kesesuaianKodeBarang.$model"
                  :state-kesesuaian-kode-barang="
                    validateState(v$.kesesuaianKodeBarang)
                  "
                  :errors-kesesuaian-kode-barang="v$.kesesuaianKodeBarang.$errors"
                  :kib-seharusnya-val="v$.kibSeharusnya.$model"
                  :state-kib-seharusnya="validateState(v$.kibSeharusnya)"
                  :errors-kib-seharusnya="v$.kibSeharusnya.$errors"
                  :kode-barang-seharusnya-val="v$.kodeBarangSeharusnya.$model"
                  :get-kobar-temp="getKobarTemp"
                  :state-kode-barang-seharusnya="
                    validateState(v$.kodeBarangSeharusnya)
                  "
                  :errors-kode-barang-seharusnya="v$.kodeBarangSeharusnya.$errors"
                  @emitInputKodeBarangSeharusnya="
                    (value) => {
                      v$.kodeBarangSeharusnya.$model = value;
                      inputKodeBarangSeharusnya();
                    }
                  "
                  @emitKodeBarang="
                    (value) => (v$.kesesuaianKodeBarang.$model = value)
                  "
                  @emitChangeKesesuaianBarang="() => changeKesesuaianBarang()"
                  @emitKibSeharusnya="
                    (value) => {
                      v$.kibSeharusnya.$model = value;
                    }
                  "
                  @emitKodeBarangSeharusnya="
                    (value) => (v$.kodeBarangSeharusnya.$model = value)
                  "
                />

                <!-- no2 -->
                <V2Ukuran
                  :satuan-val="satuanVal"
                  :ukuran-val="ukuranVal"
                  :kesesuaian-ukuran-val="v$.kesesuaianUkuran.$model"
                  :state-kesesuaian-ukuran="validateState(v$.kesesuaianUkuran)"
                  :is-disable-ukuran="isDisableUkuran"
                  :errors-kesesuaian-ukuran="v$.kesesuaianUkuran.$errors"
                  :ukuran-seharusnya-val="
                    v$.ukuranSeharusnya.$model
                      ? v$.ukuranSeharusnya.$model.toString()
                      : ''
                  "
                  :state-ukuran-seharusnya="validateState(v$.ukuranSeharusnya)"
                  :errors-ukuran-seharusnya="v$.ukuranSeharusnya.$errors"
                  :satuan-seharusnya="satuanSeharusnya"
                  @emitKesesuaianUkuran="
                    (value) => (v$.kesesuaianUkuran.$model = value)
                  "
                  @emitHandleUkuran="() => handleUkuran()"
                  @emitUkuranSeharusnya="
                    (value) => (v$.ukuranSeharusnya.$model = value)
                  "
                />

                <!-- no3 -->
                <V3SpesifikasiBarang
                  :nama-spesifikasi-barang-val="v$.namaSpesifikasiBarang.$model"
                  :state-nama-spesifikasi-barang="
                    validateState(v$.namaSpesifikasiBarang)
                  "
                  :errors-nama-spesifikasi-barang="
                    v$.namaSpesifikasiBarang.$errors
                  "
                  @emitNamaSpesifikasiBarang="
                    (value) => (v$.namaSpesifikasiBarang.$model = value)
                  "
                />

                <!-- no4 -->
                <V4Alamat
                  :alamat-val="alamatVal"
                  :kesesuaian-alamat="kesesuaianAlamat"
                  :provinsi-val="v$.provinsi.$model"
                  :state-provinsi="validateState(v$.provinsi)"
                  :errors-provinsi="v$.provinsi.$errors"
                  :kab-kota-val="v$.kabKota.$model"
                  :state-kab-kota="validateState(v$.kabKota)"
                  :errors-kab-kota="v$.kabKota.$errors"
                  :kecamatan-val="v$.kecamatan.$model"
                  :state-kecamatan="validateState(v$.kecamatan)"
                  :errors-kecamatan="v$.kecamatan.$errors"
                  :kelurahan-val="v$.kelurahan.$model"
                  :state-kelurahan="validateState(v$.kelurahan)"
                  :errors-kelurahan="v$.kelurahan.$errors"
                  :jalan-val="v$.jalan.$model"
                  :state-jalan="validateState(v$.jalan)"
                  :errors-jalan="v$.jalan.$errors"
                  :no-alamat-val="v$.noAlamat.$model"
                  :state-no-alamat="validateState(v$.noAlamat)"
                  :errors-no-alamat="v$.noAlamat.$errors"
                  :rt-val="v$.rt.$model"
                  :state-rt="validateState(v$.rt)"
                  :errors-rt="v$.rt.$errors"
                  :rw-val="v$.rw.$model"
                  :state-rw="validateState(v$.rw)"
                  :errors-rw="v$.rw.$errors"
                  :kode-pos-val="kodePos"
                  @emitProvinsi="(value) => (v$.provinsi.$model = value)"
                  @emitKabKota="(value) => (v$.kabKota.$model = value)"
                  @emitKecamatan="(value) => (v$.kecamatan.$model = value)"
                  @emitKelurahan="(value) => (v$.kelurahan.$model = value)"
                  @emitJalan="(value) => (v$.jalan.$model = value)"
                  @emitNoAlamat="(value) => (v$.noAlamat.$model = value)"
                  @emitRt="(value) => (v$.rt.$model = value)"
                  @emitChangeIntOnly="(value) => changeIntOnly(value)"
                  @emitRw="(value) => (v$.rw.$model = value)"
                  @emitKodePos="(value) => (v$.kodePos.$model = value)"
                />

                <!-- no5 -->
                <V5GedungBangunanDiatasTanahMilik
                  :gedung-bangunan-tanah-milik-val="
                    v$.gedungBangunanTanahMilik.$model
                  "
                  :state-gedung-bangunan-tanah-milik="
                    validateState(v$.gedungBangunanTanahMilik)
                  "
                  :errors-gedung-bangunan-tanah-milik="
                    v$.gedungBangunanTanahMilik.$errors
                  "
                  :is-gedung-bangunan-tanah-milik-tercatat-val="
                    v$.isGedungBangunanTanahMilikTercatat.$model
                  "
                  :state-is-gedung-bangunan-tanah-milik-tercatat="
                    validateState(v$.isGedungBangunanTanahMilikTercatat)
                  "
                  :errors-is-gedung-bangunan-tanah-milik-tercatat="
                    v$.isGedungBangunanTanahMilikTercatat.$errors
                  "
                  :gedung-bangunan-tanah-milik-pd-ukpd-val="
                    v$.gedungBangunanTanahMilikPdUkpd.$model
                  "
                  :state-gedung-bangunan-tanah-milik-pd-ukpd="
                    validateState(v$.gedungBangunanTanahMilikPdUkpd)
                  "
                  :errors-gedung-bangunan-tanah-milik-pd-ukpd="
                    v$.gedungBangunanTanahMilikPdUkpd.$errors
                  "
                  :data-pd-ukpd="dataPdUkpd"
                  :gedung-bangunan-tanah-milik-kobar-val="
                    v$.gedungBangunanTanahMilikKobar.$model
                  "
                  :data-gedung-bangunan-tanah-milik-kobar="
                    dataGedungBangunanTanahMilikKobar
                  "
                  :state-gedung-bangunan-tanah-milik-kobar="
                    validateState(v$.gedungBangunanTanahMilikKobar)
                  "
                  :errors-gedung-bangunan-tanah-milik-kobar="
                    v$.gedungBangunanTanahMilikKobar.$errors
                  "
                  :gedung-bangunan-tanah-milik-register-val="
                    v$.gedungBangunanTanahMilikRegister.$model
                  "
                  :state-gedung-bangunan-tanah-milik-register="
                    validateState(v$.gedungBangunanTanahMilikRegister)
                  "
                  :data-gedung-bangunan-tanah-milik-register="
                    dataGedungBangunanTanahMilikRegister
                  "
                  :errors-gedung-bangunan-tanah-milik-register="
                    v$.gedungBangunanTanahMilikRegister.$errors
                  "
                  :gedung-bangunan-tanah-milik-keterangan-val="
                    v$.gedungBangunanTanahMilikKeterangan.$model
                  "
                  :state-gedung-bangunan-tanah-milik-keterangan="
                    validateState(v$.gedungBangunanTanahMilikKeterangan)
                  "
                  :errors-gedung-bangunan-tanah-milik-keterangan="
                    v$.gedungBangunanTanahMilikKeterangan.$errors
                  "
                  :gedung-bangunan-tanah-milik-sebutkan-val="
                    v$.gedungBangunanTanahMilikSebutkan.$model
                  "
                  :state-gedung-bangunan-tanah-milik-sebutkan="
                    validateState(v$.gedungBangunanTanahMilikSebutkan)
                  "
                  :errors-gedung-bangunan-tanah-milik-sebutkan="
                    v$.gedungBangunanTanahMilikSebutkan.$errors
                  "
                  @emitGedungBangunanTanahMilik="
                    (value) => (v$.gedungBangunanTanahMilik.$model = value)
                  "
                  @emitIsGedungBangunanTanahMilikTercatat="
                    (value) =>
                      (v$.isGedungBangunanTanahMilikTercatat.$model = value)
                  "
                  @emitGedungBangunanTanahMilikPdUkpd="
                    (value) =>
                      (v$.gedungBangunanTanahMilikPdUkpd.$model = value)
                  "
                  @emitInputGedungBangunanTanahMilikPdUkpd="
                    (value) => {
                      v$.gedungBangunanTanahMilikPdUkpd.$model = value;
                      inputGedungBangunanTanahMilikPdUkpd();
                    }
                  "
                  @emitGedungBangunanTanahMilikKobar="
                    (value) => (v$.gedungBangunanTanahMilikKobar.$model = value)
                  "
                  @emitInputGedungBangunanTanahMilikKobar="
                    (value) => {
                      v$.gedungBangunanTanahMilikKobar.$model = value;
                      inputGedungBangunanTanahMilikKobar();
                    }
                  "
                  @emitSearchIndikasiGandaKobar="
                    (value) => searchIndikasiGandaKobar(value)
                  "
                  @emitGedungBangunanTanahMilikRegister="
                    (value) =>
                      (v$.gedungBangunanTanahMilikRegister.$model = value)
                  "
                  @emitGedungBangunanTanahMilikKeterangan="
                    (value) =>
                      (v$.gedungBangunanTanahMilikKeterangan.$model = value)
                  "
                  @emitGedungBangunanTanahMilikSebutkan="
                    (value) =>
                      (v$.gedungBangunanTanahMilikSebutkan.$model = value)
                  "
                />

                <V6IndikasiTercatatGanda
                  :is-indikasi-ganda-val="v$.isIndikasiGanda.$model"
                  :state-is-indikasi-ganda="validateState(v$.isIndikasiGanda)"
                  :errors-is-indikasi-ganda="v$.isIndikasiGanda.$errors"
                  :indikasi-ganda-dengan-val="v$.indikasiGandaDengan.$model"
                  :data-indikasi-ganda-dengan="dataIndikasiGandaDengan"
                  :state-indikasi-ganda-dengan="
                    validateState(v$.indikasiGandaDengan)
                  "
                  :errors-indikasi-ganda-dengan="v$.indikasiGandaDengan.$errors"
                  :indikasi-ganda-sebutkan-val="v$.indikasiGandaSebutkan.$model"
                  :state-indikasi-ganda-sebutkan="
                    validateState(v$.indikasiGandaSebutkan)
                  "
                  :errors-indikasi-ganda-sebutkan="
                    v$.indikasiGandaSebutkan.$errors
                  "
                  :indikasi-ganda-pd-ukpd-val="v$.indikasiGandaPdUkpd.$model"
                  :state-indikasi-ganda-pd-ukpd="
                    validateState(v$.indikasiGandaPdUkpd)
                  "
                  :data-indikasi-ganda-pd-ukpd="dataIndikasiGandaPdUkpd"
                  :errors-indikasi-ganda-pd-ukpd="v$.indikasiGandaPdUkpd.$errors"
                  :is-load-indikasi-ganda-pd-ukpd="isLoadIndikasiGandaPdUkpd"
                  :is-load-indikasi-ganda-register="isLoadIndikasiGandaRegister"
                  :indikasi-ganda-kobar-val="v$.indikasiGandaKobar.$model"
                  :state-indikasi-ganda-kobar="
                    validateState(v$.indikasiGandaKobar)
                  "
                  :errors-indikasi-ganda-kobar="v$.indikasiGandaKobar.$errors"
                  :data-indikasi-ganda-kobar="dataIndikasiGandaKobar"
                  :indikasi-ganda-register-val="v$.indikasiGandaRegister.$model"
                  :state-indikasi-ganda-register="
                    validateState(v$.indikasiGandaRegister)
                  "
                  :errors-indikasi-ganda-register="
                    v$.indikasiGandaRegister.$errors
                  "
                  :data-indikasi-ganda-register="dataIndikasiGandaRegister"
                  @emitIsIndikasiGanda="
                    (value) => (v$.isIndikasiGanda.$model = value)
                  "
                  @emitIndikasiGandaDengan="
                    (value) => (v$.indikasiGandaDengan.$model = value)
                  "
                  @emitChangeIndikasiGandaDengan="
                    () => changeIndikasiGandaDengan()
                  "
                  @emitIndikasiGandaSebutkan="
                    (value) => (v$.indikasiGandaSebutkan.$model = value)
                  "
                  @emitIndikasiGandaPdUkpd="
                    (value) => (v$.indikasiGandaPdUkpd.$model = value)
                  "
                  @emitInputIndikasiGandaPdUkpd="
                    (value) => {
                      v$.indikasiGandaPdUkpd.$model = value;
                      inputIndikasiGandaPdUkpd();
                    }
                  "
                  @emitIndikasiGandaKobar="
                    (value) => (v$.indikasiGandaKobar.$model = value)
                  "
                  @emitInputIndikasiGandaKobar="
                    (value) => {
                      v$.indikasiGandaKobar.$model = value;
                      inputIndikasiGandaKobar();
                    }
                  "
                  @emitSearchIndikasiGandaKobar="
                    (value) => searchIndikasiGandaKobar(value)
                  "
                  @emitIndikasiGandaRegister="
                    (value) => (v$.indikasiGandaRegister.$model = value)
                  "
                />

                <V7IndikasiTercatatGabungan
                  :indikasi-gabungan-val="v$.indikasiGabungan.$model"
                  :data-indikasi-gabungan="dataIndikasiGabungan"
                  :state-indikasi-gabungan="validateState(v$.indikasiGabungan)"
                  :errors-indikasi-gabungan="v$.indikasiGabungan.$errors"
                  :indikasi-gabungan-keterangan-val="
                    v$.indikasiGabunganKeterangan.$model
                  "
                  :state-indikasi-gabungan-keterangan="
                    validateState(v$.indikasiGabunganKeterangan)
                  "
                  :errors-indikasi-gabungan-keterangan="
                    v$.indikasiGabunganKeterangan.$errors
                  "
                  @emitIndikasiGabungan="
                    (value) => (v$.indikasiGabungan.$model = value)
                  "
                  @emitIndikasiGabunganKeterangan="
                    (value) => (v$.indikasiGabunganKeterangan.$model = value)
                  "
                />

                <b-form-group
                  label="8. SK Penggunaan"
                  label-for="skPenggunaan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-radio
                    id="skPenggunaan"
                    v-model="v$.skPenggunaan.$model"
                    :state="validateState(v$.skPenggunaan)"
                    value="1"
                  >
                    Ada SK Penggunaan
                  </b-form-radio>
                  <b-col
                    v-if="skPenggunaan === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Nomor SK Penggunaan"
                      label-for="nomorSkPenggunaan"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-input
                        id="nomorSkPenggunaan"
                        v-model="v$.nomorSkPenggunaan.$model"
                        :state="validateState(v$.nomorSkPenggunaan)"
                        @keydown="changeIntOnly"
                      />
                      <b-form-invalid-feedback
                        v-for="(error, index) of v$.nomorSkPenggunaan.$errors"
                        :key="index"
                      >
                        <span v-if="error.$validator == 'checkField'">Nomor SK Penggunaan Harus di Isi Jika Ada SK
                          Penggunaan</span>
                        <span v-else>{{ error.$message }}</span>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      label="Tahun SK Penggunaan"
                      label-for="tahunSkPenggunaan"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-input
                        id="tahunSkPenggunaan"
                        v-model="v$.tahunSkPenggunaan.$model"
                        :state="validateState(v$.tahunSkPenggunaan)"
                        maxlength="4"
                        @keydown="changeIntOnly"
                      />
                      <b-form-invalid-feedback
                        v-for="(error, index) of v$.tahunSkPenggunaan.$errors"
                        :key="index"
                      >
                        <span v-if="error.$validator == 'checkField'">Tahun SK Penggunaan Harus di Isi Jika Ada SK
                          Penggunaan</span>
                        <span v-else>{{ error.$message }}</span>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-form-radio
                    v-model="v$.skPenggunaan.$model"
                    :state="validateState(v$.skPenggunaan)"
                    value="0"
                  >
                    Tidak Ada SK Penggunaan
                  </b-form-radio>
                  <small
                    v-for="(error, index) of v$.skPenggunaan.$errors"
                    :key="index"
                    class="text-danger"
                  >
                    <span>{{ error.$message }}</span>
                  </small>
                </b-form-group>

                <b-form-group
                  label="9. Penggunaan"
                  label-for="penggunaan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-select
                    id="penggunaan"
                    v-model="v$.penggunaan.$model"
                    :options="dataPenggunaan"
                    :state="validateState(v$.penggunaan)"
                  />
                  <b-form-invalid-feedback
                    v-for="(error, index) of v$.penggunaan.$errors"
                    :key="index"
                  >
                    {{ error.$message }}
                  </b-form-invalid-feedback>

                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <!-- no. 2 -->
                    <b-form-group
                      v-if="penggunaan === '2'"
                      label="Digunakan Untuk"
                      label-for="digunakanUntuk"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-input
                        id="digunakanUntuk"
                        v-model="v$.digunakanUntuk.$model[0].value"
                        :state="
                          validateState2(
                            v$.digunakanUntuk.$each.$response.$data[0].value
                          )
                        "
                      />
                      <b-form-invalid-feedback
                        v-for="(error, index) of v$.digunakanUntuk.$each
                          .$response.$errors[0].value"
                        :key="index"
                      >
                        <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan
                          Digunakan Sendiri Seluruhnya Oleh PD/UKPD</span>
                        <span v-else>{{ error.$message }}</span>
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <!-- no. 3 -->
                    <div v-else-if="penggunaan === '3'">
                      <div
                        v-for="(item, index) of v$.pdUkpd.$model"
                        :key="index"
                      >
                        <b-form-group
                          label="PD/UKPD"
                          label-for="pdUkpd"
                          label-size="lg"
                          label-class="pb-0 pt-0"
                        >
                          <b-row>
                            <b-col cols="11">
                              <v-select
                                v-model="item.value"
                                :options="dataPdUkpd"
                                label="text"
                              />
                            </b-col>
                            <b-col
                              cols="1"
                              align-self="center"
                              class="text-right"
                            >
                              <b-button
                                v-if="index == 0"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="btn-icon"
                                size="sm"
                                @click="
                                  () => {
                                    pdUkpd.push({
                                      value: defaultKolok,
                                    });
                                    digunakanUntuk.push({
                                      value: '',
                                    });
                                  }
                                "
                              >
                                <feather-icon icon="PlusIcon" />
                              </b-button>
                              <b-button
                                v-else
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="danger"
                                class="btn-icon"
                                size="sm"
                                @click="
                                  () => {
                                    pdUkpd.splice(index, 1);
                                    digunakanUntuk.splice(index, 1);
                                  }
                                "
                              >
                                <feather-icon icon="MinusIcon" />
                              </b-button>
                            </b-col>
                          </b-row>
                          <small
                            v-for="(error, index2) of v$.pdUkpd.$each.$response
                              .$errors[index].value"
                            :key="index2"
                            class="text-danger"
                          >
                            <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Penggunaan Digunakan
                              Seluruhnya Oleh PD/UKPD Lain</span>
                            <span v-else>{{ error.$message }}</span>
                          </small>
                        </b-form-group>

                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="digunakanUntuk"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-form-input
                              id="digunakanUntuk"
                              v-model="v$.digunakanUntuk.$model[index].value"
                              :state="
                                validateState2(
                                  v$.digunakanUntuk.$each.$response.$data[index]
                                    .value
                                )
                              "
                            />
                            <b-form-invalid-feedback
                              v-for="(error, index2) of v$.digunakanUntuk.$each
                                .$response.$errors[index].value"
                              :key="index2"
                            >
                              <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan
                                Digunakan Seluruhnya Oleh PD/UKPD Lain</span>
                              <span v-else>{{ error.$message }}</span>
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </div>
                    </div>

                    <!-- no. 4 -->
                    <div v-else-if="penggunaan === '4'">
                      <b-form-checkbox
                        v-model="digunakanBersama"
                        value="1"
                      >
                        PD/UKPD Lain
                      </b-form-checkbox>
                      <b-col
                        v-if="digunakanBersama.includes('1')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, index) of v$.pdUkpd.$model"
                          :key="index"
                        >
                          <b-form-group
                            label="PD/UKPD"
                            label-for="pdUkpd"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-row>
                              <b-col cols="11">
                                <v-select
                                  v-model="item.value"
                                  label="text"
                                  :options="dataPdUkpd"
                                />
                              </b-col>
                              <b-col
                                cols="1"
                                align-self="center"
                                class="text-right"
                              >
                                <b-button
                                  v-if="index == 0"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="primary"
                                  class="btn-icon"
                                  size="sm"
                                  @click="
                                    () => {
                                      pdUkpd.push({
                                        value: defaultKolok,
                                      });
                                      digunakanUntuk.push({
                                        value: '',
                                      });
                                    }
                                  "
                                >
                                  <feather-icon icon="PlusIcon" />
                                </b-button>
                                <b-button
                                  v-else
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="danger"
                                  class="btn-icon"
                                  size="sm"
                                  @click="
                                    () => {
                                      pdUkpd.splice(index, 1);
                                      digunakanUntuk.splice(index, 1);
                                    }
                                  "
                                >
                                  <feather-icon icon="MinusIcon" />
                                </b-button>
                              </b-col>
                            </b-row>
                            <small
                              v-for="(error, index2) of v$.pdUkpd.$each
                                .$response.$errors[index].value"
                              :key="index2"
                              class="text-danger"
                            >
                              <span v-if="error.$validator == 'checkSelectCostum'">PD/UKPD Harus di Isi Jika Penggunaan Digunakan
                                Bersama Oleh PD/UKPD Lain Dan/Atau Pihak
                                Lain</span>
                              <span v-else>{{ error.$message }}</span>
                            </small>
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <b-form-group
                              label="Digunakan Untuk"
                              label-for="digunakanUntuk"
                              label-size="lg"
                              label-class="pb-0 pt-0"
                            >
                              <b-form-input
                                id="digunakanUntuk"
                                v-model="v$.digunakanUntuk.$model[index].value"
                                :state="
                                  validateState2(
                                    v$.digunakanUntuk.$each.$response.$data[
                                      index
                                    ].value
                                  )
                                "
                              />
                              <b-form-invalid-feedback
                                v-for="(error, index2) of v$.digunakanUntuk
                                  .$each.$response.$errors[index].value"
                                :key="index2"
                              >
                                <span v-if="error.$validator == 'checkField'">Digunakan Untuk Harus di Isi Jika Penggunaan
                                  Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                  Pihak Lain</span>
                                <span v-else>{{ error.$message }}</span>
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </div>
                      </b-col>
                      <b-form-checkbox
                        v-model="digunakanBersama"
                        value="0"
                      >
                        Instansi / Pihak Lain
                      </b-form-checkbox>
                      <b-col
                        v-if="digunakanBersama.includes('0')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, indexx) of v$.pemanfaat.$model"
                          :key="indexx + 'i'"
                        >
                          <b-form-group
                            label="Pemanfaat"
                            label-for="pemanfaat"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-row>
                              <b-col cols="11">
                                <b-form-select
                                  id="pemanfaat"
                                  v-model="item.value"
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .value
                                    )
                                  "
                                  :options="dataPemanfaat"
                                />
                              </b-col>
                              <b-col
                                cols="1"
                                align-self="center"
                                class="text-right"
                              >
                                <b-button
                                  v-if="indexx == 0"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="primary"
                                  class="btn-icon"
                                  size="sm"
                                  @click="
                                    () => {
                                      pemanfaat.push({
                                        value: null,
                                        namaPemanfaat: '',
                                        dasarPenggunaan: '',
                                        dasarPenggunaanTipe: '',
                                      });
                                    }
                                  "
                                >
                                  <feather-icon icon="PlusIcon" />
                                </b-button>
                                <b-button
                                  v-else
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="danger"
                                  class="btn-icon"
                                  size="sm"
                                  @click="pemanfaat.splice(indexx, 1)"
                                >
                                  <feather-icon icon="MinusIcon" />
                                </b-button>
                              </b-col>
                            </b-row>
                            <small
                              v-for="(error, index2) of v$.pemanfaat.$each
                                .$response.$errors[indexx].value"
                              :key="index2"
                              class="text-danger"
                            >
                              <span v-if="error.$validator == 'checkField'">Pemanfaat Harus di Isi Jika Penggunaan
                                Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                Pihak Lain</span>
                              <span v-else>{{ error.$message }}</span>
                            </small>
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                                label-size="lg"
                                label-class="pb-0 pt-0"
                              >
                                <b-form-input
                                  v-model="
                                    v$.pemanfaat.$model[indexx].namaPemanfaat
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .namaPemanfaat
                                    )
                                  "
                                />
                                <b-form-invalid-feedback
                                  v-for="(error, index2) of v$.pemanfaat.$each
                                    .$response.$errors[indexx].namaPemanfaat"
                                  :key="index2"
                                >
                                  <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan
                                    Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                    Pihak Lain</span>
                                  <span v-else>{{ error.$message }}</span>
                                </b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group
                                label="Dasar Pemanfaatan"
                                label-for="dasarPenggunaan"
                                label-size="lg"
                                label-class="pb-0 pt-0"
                              >
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx].dasarPenggunaan
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaan
                                    )
                                  "
                                  value="1"
                                >
                                  Ada Pinjam Pakai
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx].dasarPenggunaan
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaan
                                    )
                                  "
                                  value="0"
                                >
                                  Tidak Ada Pinjam Pakai
                                </b-form-radio>
                                <small
                                  v-for="(error, index2) of v$.pemanfaat.$each
                                    .$response.$errors[indexx].dasarPenggunaan"
                                  :key="index2"
                                  class="text-danger"
                                >
                                  <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Harus di Isi Jika
                                    Penggunaan Digunakan Bersama Oleh PD/UKPD
                                    Lain Dan/Atau Pihak Lain</span>
                                  <span v-else>{{ error.$message }}</span>
                                </small>
                              </b-form-group>
                            </div>

                            <div v-if="pemanfaat[indexx].value === '3'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                                label-size="lg"
                                label-class="pb-0 pt-0"
                              >
                                <b-form-input
                                  v-model="
                                    v$.pemanfaat.$model[indexx].namaPemanfaat
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .namaPemanfaat
                                    )
                                  "
                                />
                                <b-form-invalid-feedback
                                  v-for="(error, index2) of v$.pemanfaat.$each
                                    .$response.$errors[indexx].namaPemanfaat"
                                  :key="index2"
                                >
                                  <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan
                                    Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                    Pihak Lain</span>
                                  <span v-else>{{ error.$message }}</span>
                                </b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group
                                label="Dasar Pemanfaatan"
                                label-for="kodeRegisterBarang"
                                label-size="lg"
                                label-class="pb-0 pt-0"
                              >
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx].dasarPenggunaan
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaan
                                    )
                                  "
                                  value="1"
                                >
                                  Ada Dasar Pemanfaatan
                                </b-form-radio>

                                <b-col
                                  v-if="
                                    pemanfaat[indexx].dasarPenggunaan === '1'
                                  "
                                  cols="11"
                                  offset-md="1"
                                >
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="6"
                                  >
                                    Sewa
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="5"
                                  >
                                    Pinjam Pakai
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="3"
                                  >
                                    Bangun Guna Serah
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="4"
                                  >
                                    Bangun Serah Guna
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="7"
                                  >
                                    KSP (Kerjasama Pemanfaatan)
                                  </b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      v$.pemanfaat.$model[indexx]
                                        .dasarPenggunaanTipe
                                    "
                                    :state="
                                      validateState2(
                                        v$.pemanfaat.$each.$response.$data[
                                          indexx
                                        ].dasarPenggunaanTipe
                                      )
                                    "
                                    value="1"
                                  >
                                    KSPI
                                  </b-form-radio>
                                  <small
                                    v-for="(error, index2) of v$.pemanfaat.$each
                                      .$response.$errors[indexx]
                                      .dasarPenggunaanTipe"
                                    :key="index2"
                                    class="text-danger"
                                  >
                                    <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Tipe Harus di Isi Jika
                                      Ada Dasar Pemanfaatan</span>
                                    <span v-else>{{ error.$message }}</span>
                                  </small>
                                </b-col>

                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx].dasarPenggunaan
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaan
                                    )
                                  "
                                  value="0"
                                >
                                  Tidak Ada Dasar Pemanfaatan
                                </b-form-radio>
                                <small
                                  v-for="(error, index2) of v$.pemanfaat.$each
                                    .$response.$errors[indexx].dasarPenggunaan"
                                  :key="index2"
                                  class="text-danger"
                                >
                                  <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Harus di Isi Jika
                                    Penggunaan Digunakan Bersama Oleh PD/UKPD
                                    Lain Dan/Atau Pihak Lain</span>
                                  <span v-else>{{ error.$message }}</span>
                                </small>
                              </b-form-group>
                            </div>
                          </b-col>
                        </div>
                      </b-col>
                    </div>

                    <!-- no. 5 -->
                    <div v-else-if="penggunaan === '5'">
                      <div
                        v-for="(item, indexx) of v$.pemanfaat.$model"
                        :key="indexx + 'i'"
                      >
                        <b-form-group
                          label="Pemanfaat"
                          label-for="pemanfaat"
                          label-size="lg"
                          label-class="pb-0 pt-0"
                        >
                          <b-row>
                            <b-col cols="11">
                              <b-form-select
                                id="pemanfaat"
                                v-model="item.value"
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .value
                                  )
                                "
                                :options="dataPemanfaat"
                              />
                            </b-col>
                            <b-col
                              cols="1"
                              align-self="center"
                              class="text-right"
                            >
                              <b-button
                                v-if="indexx == 0"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="btn-icon"
                                size="sm"
                                @click="
                                  () => {
                                    pemanfaat.push({
                                      value: null,
                                      namaPemanfaat: '',
                                      dasarPenggunaan: '',
                                      dasarPenggunaanTipe: '',
                                    });
                                  }
                                "
                              >
                                <feather-icon icon="PlusIcon" />
                              </b-button>
                              <b-button
                                v-else
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="danger"
                                class="btn-icon"
                                size="sm"
                                @click="pemanfaat.splice(indexx, 1)"
                              >
                                <feather-icon icon="MinusIcon" />
                              </b-button>
                            </b-col>
                          </b-row>
                          <small
                            v-for="(error, index2) of v$.pemanfaat.$each
                              .$response.$errors[indexx].value"
                            :key="index2"
                            class="text-danger"
                          >
                            <span v-if="error.$validator == 'checkField'">Pemanfaat Harus di Isi Jika Penggunaan Digunakan
                              Bersama Oleh PD/UKPD Lain Dan/Atau Pihak
                              Lain</span>
                            <span v-else>{{ error.$message }}</span>
                          </small>
                        </b-form-group>
                        <b-col
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <div v-if="pemanfaat[indexx].value === '1' || pemanfaat[indexx].value === '2'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                              label-size="lg"
                              label-class="pb-0 pt-0"
                            >
                              <b-form-input
                                v-model="
                                  v$.pemanfaat.$model[indexx].namaPemanfaat
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .namaPemanfaat
                                  )
                                "
                              />
                              <b-form-invalid-feedback
                                v-for="(error, index2) of v$.pemanfaat.$each
                                  .$response.$errors[indexx].namaPemanfaat"
                                :key="index2"
                              >
                                <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan
                                  Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                  Pihak Lain</span>
                                <span v-else>{{ error.$message }}</span>
                              </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group
                              label="Dasar Pemanfaatan"
                              label-for="dasarPenggunaan"
                              label-size="lg"
                              label-class="pb-0 pt-0"
                            >
                              <b-form-radio
                                v-model="
                                  v$.pemanfaat.$model[indexx].dasarPenggunaan
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .dasarPenggunaan
                                  )
                                "
                                value="1"
                              >
                                Ada Pinjam Pakai
                              </b-form-radio>
                              <b-form-radio
                                v-model="
                                  v$.pemanfaat.$model[indexx].dasarPenggunaan
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .dasarPenggunaan
                                  )
                                "
                                value="0"
                              >
                                Tidak Ada Pinjam Pakai
                              </b-form-radio>
                              <small
                                v-for="(error, index2) of v$.pemanfaat.$each
                                  .$response.$errors[indexx].dasarPenggunaan"
                                :key="index2"
                                class="text-danger"
                              >
                                <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Harus di Isi Jika
                                  Penggunaan Digunakan Bersama Oleh PD/UKPD Lain
                                  Dan/Atau Pihak Lain</span>
                                <span v-else>{{ error.$message }}</span>
                              </small>
                            </b-form-group>
                          </div>

                          <div v-if="pemanfaat[indexx].value === '3'">
                            <b-form-group
                              label="Nama Pemanfaat"
                              label-for="namaPemanfaat"
                              label-size="lg"
                              label-class="pb-0 pt-0"
                            >
                              <b-form-input
                                v-model="
                                  v$.pemanfaat.$model[indexx].namaPemanfaat
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .namaPemanfaat
                                  )
                                "
                              />
                              <b-form-invalid-feedback
                                v-for="(error, index2) of v$.pemanfaat.$each
                                  .$response.$errors[indexx].namaPemanfaat"
                                :key="index2"
                              >
                                <span v-if="error.$validator == 'checkField'">Nama Pemanfaat Harus di Isi Jika Penggunaan
                                  Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau
                                  Pihak Lain</span>
                                <span v-else>{{ error.$message }}</span>
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                              label="Dasar Pemanfaatan"
                              label-for="kodeRegisterBarang"
                              label-size="lg"
                              label-class="pb-0 pt-0"
                            >
                              <b-form-radio
                                v-model="
                                  v$.pemanfaat.$model[indexx].dasarPenggunaan
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .dasarPenggunaan
                                  )
                                "
                                value="1"
                              >
                                Ada Dasar Pemanfaatan
                              </b-form-radio>

                              <b-col
                                v-if="pemanfaat[indexx].dasarPenggunaan === '1'"
                                cols="11"
                                offset-md="1"
                              >
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="6"
                                >
                                  Sewa
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="5"
                                >
                                  Pinjam Pakai
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="3"
                                >
                                  Bangun Guna Serah
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="4"
                                >
                                  Bangun Serah Guna
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="7"
                                >
                                  KSP (Kerjasama Pemanfaatan)
                                </b-form-radio>
                                <b-form-radio
                                  v-model="
                                    v$.pemanfaat.$model[indexx]
                                      .dasarPenggunaanTipe
                                  "
                                  :state="
                                    validateState2(
                                      v$.pemanfaat.$each.$response.$data[indexx]
                                        .dasarPenggunaanTipe
                                    )
                                  "
                                  value="1"
                                >
                                  KSPI
                                </b-form-radio>
                                <small
                                  v-for="(error, index2) of v$.pemanfaat.$each
                                    .$response.$errors[indexx]
                                    .dasarPenggunaanTipe"
                                  :key="index2"
                                  class="text-danger"
                                >
                                  <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Tipe Harus di Isi Jika
                                    Ada Dasar Pemanfaatan</span>
                                  <span v-else>{{ error.$message }}</span>
                                </small>
                              </b-col>

                              <b-form-radio
                                v-model="
                                  v$.pemanfaat.$model[indexx].dasarPenggunaan
                                "
                                :state="
                                  validateState2(
                                    v$.pemanfaat.$each.$response.$data[indexx]
                                      .dasarPenggunaan
                                  )
                                "
                                value="0"
                              >
                                Tidak Ada Dasar Pemanfaatan
                              </b-form-radio>
                              <small
                                v-for="(error, index2) of v$.pemanfaat.$each
                                  .$response.$errors[indexx].dasarPenggunaan"
                                :key="index2"
                                class="text-danger"
                              >
                                <span v-if="error.$validator == 'checkField'">Dasar Pemanfaatan Harus di Isi Jika
                                  Penggunaan Digunakan Bersama Oleh PD/UKPD Lain
                                  Dan/Atau Pihak Lain</span>
                                <span v-else>{{ error.$message }}</span>
                              </small>
                            </b-form-group>
                          </div>
                        </b-col>
                      </div>
                    </div>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="10. Apakah Bangunan Merupakan Bangunan Bertingkat ?"
                  label-for="kodeRegisterBarang"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-form-radio
                    v-model="v$.isBertingkat.$model"
                    value="0"
                    :state="validateState(v$.isBertingkat)"
                    @change="changeIsBertingkat"
                  >
                    Tidak Bertingkat
                  </b-form-radio>
                  <b-form-radio
                    v-model="v$.isBertingkat.$model"
                    value="1"
                    :state="validateState(v$.isBertingkat)"
                    @change="changeIsBertingkat"
                  >
                    Ya, Bertingkat
                    <small class="text-warning">Bertingkat 1 lantai adalah bangunan yang memiliki
                      bangunan 1 tingkat di atas lantai dasar, tidak termasuk
                      basement dan rooftop</small>
                  </b-form-radio>
                  <small
                    v-for="(error, index) of v$.isBertingkat.$errors"
                    :key="index"
                    class="text-danger"
                  >
                    <span>{{ error.$message }}</span>
                  </small>

                  <b-col
                    v-if="isBertingkat === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-select
                      id="bertingkatSeharusnya"
                      v-model="v$.bertingkatSeharusnya.$model"
                      :state="validateState(v$.bertingkatSeharusnya)"
                      :options="dataBertingkatSeharusnya"
                      @change="changeBertingkatSeharusnya"
                    />
                    <b-form-invalid-feedback
                      v-for="(error, index) of v$.bertingkatSeharusnya.$errors"
                      :key="index"
                    >
                      <span v-if="error.$validator == 'checkField'">Bertingkat Seharusnya Harus di Isi Jika Tidak
                        Bertingkat</span>
                      <span v-else>{{ error.$message }}</span>
                    </b-form-invalid-feedback>
                  </b-col>
                </b-form-group>

                <b-form-group
                  label="11. Potensi Pemanfaatan"
                  label-for="potensiPemanfaatan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <b-col
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="a. Apakah Terdapat Lantai Yang Tidak Digunakan ?"
                      label-for="isLantaiDigunakan"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-radio
                        v-model="v$.isLantaiDigunakan.$model"
                        value="1"
                        :state="validateState(v$.isLantaiDigunakan)"
                        @change="keyUpLantai"
                      >
                        Ya
                      </b-form-radio>
                      <b-col
                        v-if="isLantaiDigunakan === '1'"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Jumlah Seluruh Lantai"
                          label-for="jumlahSeluruhLantai"
                          label-size="lg"
                          label-class="pb-0 pt-0"
                        >
                          <b-form-input
                            id="jumlahSeluruhLantai"
                            v-model="v$.jumlahSeluruhLantai.$model"
                            :state="validateState(v$.jumlahSeluruhLantai)"
                            disabled
                          />
                          <b-form-invalid-feedback
                            v-for="(error, index) of v$.jumlahSeluruhLantai
                              .$errors"
                            :key="index"
                          >
                            <span v-if="error.$validator == 'checkField'">Jumlah Seluruh Lantai Harus di Isi Jika Terdapat
                              Lantai Yang Tidak Digunakan</span>
                            <span v-else>{{ error.$message }}</span>
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <label
                          for="jumlahLantaiTidakDigunakan"
                          class="d-block col-form-label-lg pb-0 pt-0"
                        >
                          Jumlah Lantai Yang Tidak Digunakan
                          <feather-icon
                            v-b-tooltip.hover
                            icon="AlertCircleIcon"
                            class="text-warning"
                            title="Lantai tidak digunakan apabila penggunaan lantai kurang dari 50% dari total luas lantai"
                          />
                        </label>
                        <b-form-input
                          id="jumlahLantaiTidakDigunakan"
                          v-model="v$.jumlahLantaiTidakDigunakan.$model"
                          :state="validateState(v$.jumlahLantaiTidakDigunakan)"
                          :disabled="
                            isBertingkat === '0' && isLantaiDigunakan === '1'
                          "
                          @keydown="changeIntOnly"
                          @keyup="keyUpLantai"
                        />
                        <b-form-invalid-feedback
                          v-for="(error, index) of v$.jumlahLantaiTidakDigunakan
                            .$errors"
                          :key="index"
                        >
                          <span v-if="error.$validator == 'checkField'">Jumlah Lantai Yang Tidak Digunakan Harus di Isi
                            Jika Terdapat Lantai Yang Tidak Digunakan</span>
                          <span v-else>{{ error.$message }}</span>
                        </b-form-invalid-feedback>
                        <b-form-group
                          label="Jumlah Lantai Yang Digunakan"
                          label-for="jumlahLantaiDigunakan"
                          label-size="lg"
                          label-class="pb-0 pt-1"
                        >
                          <b-form-input
                            id="jumlahLantaiDigunakan"
                            v-model="v$.jumlahLantaiDigunakan.$model"
                            :state="validateState(v$.jumlahLantaiDigunakan)"
                            disabled
                          />
                          <b-form-invalid-feedback
                            v-for="(error, index) of v$.jumlahLantaiDigunakan
                              .$errors"
                            :key="index"
                          >
                            <span v-if="error.$validator == 'checkField'">Jumlah Lantai Yang Digunakan Harus di Isi Jika
                              Terdapat Lantai Yang Tidak Digunakan</span>
                            <span v-else-if="error.$validator == 'checkLantai'">Jumlah Lantai Yang Digunakan Harus Lebih Kecil
                              Dari Jumlah Seluruh Lantai</span>
                            <span v-else>{{ error.$message }}</span>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-form-radio
                        v-model="v$.isLantaiDigunakan.$model"
                        value="0"
                        :state="validateState(v$.isLantaiDigunakan)"
                        @change="keyUpLantai"
                      >
                        Tidak
                      </b-form-radio>
                      <small
                        v-for="(error, index) of v$.isLantaiDigunakan.$errors"
                        :key="index"
                        class="text-danger"
                      >
                        <span>{{ error.$message }}</span>
                      </small>
                    </b-form-group>

                    <b-form-group
                      label="b. Atap Beton"
                      label-for="isAtapBeton"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-radio
                        v-model="v$.isAtapBeton.$model"
                        value="1"
                        :state="validateState(v$.isAtapBeton)"
                      >
                        Ada (Memiliki Atap Beton)
                      </b-form-radio>
                      <b-col
                        v-if="isAtapBeton === '1'"
                        cols="11"
                        offset-md="1"
                      >
                        <b-form-radio
                          v-model="v$.isAtapBetonIsDigunakan.$model"
                          value="1"
                          :state="validateState(v$.isAtapBetonIsDigunakan)"
                        >
                          Digunakan
                          <feather-icon
                            v-b-tooltip.hover
                            icon="AlertCircleIcon"
                            class="text-warning"
                            title="Atap beton adalah ruang datar sebagai penutup bagian atas gedung dan bangunan yang dibangun menggunakan beban dan/atau campuran beton"
                          />
                        </b-form-radio>
                        <b-col
                          v-if="
                            isAtapBeton === '1' &&
                              isAtapBetonIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="atapBetonDigunakan"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-form-input
                              id="atapBetonDigunakan"
                              v-model="v$.atapBetonDigunakan.$model"
                              :state="validateState(v$.atapBetonDigunakan)"
                            />
                            <b-form-invalid-feedback
                              v-for="(error, index) of v$.atapBetonDigunakan
                                .$errors"
                              :key="index"
                            >
                              {{ error.$message }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="v$.isAtapBetonIsDigunakan.$model"
                          value="0"
                          :state="validateState(v$.isAtapBetonIsDigunakan)"
                        >
                          Tidak Digunakan
                        </b-form-radio>
                        <small
                          v-for="(error, index) of v$.isAtapBetonIsDigunakan
                            .$errors"
                          :key="index"
                          class="text-danger"
                        >
                          <span>{{ error.$message }}</span>
                        </small>
                      </b-col>
                      <b-form-radio
                        v-model="v$.isAtapBeton.$model"
                        value="0"
                        :state="validateState(v$.isAtapBeton)"
                      >
                        Tidak Ada Atap Beton
                      </b-form-radio>
                      <small
                        v-for="(error, index) of v$.isAtapBeton.$errors"
                        :key="index"
                        class="text-danger"
                      >
                        <span>{{ error.$message }}</span>
                      </small>
                    </b-form-group>

                    <b-form-group
                      label="c. Basement"
                      label-for="isBasement"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-radio
                        v-model="v$.isBasement.$model"
                        value="1"
                        :state="validateState(v$.isBasement)"
                      >
                        Ada (Memiliki Basement)
                      </b-form-radio>
                      <b-col
                        v-if="isBasement === '1'"
                        cols="11"
                        offset-md="1"
                      >
                        <b-form-radio
                          v-model="v$.isBasementIsDigunakan.$model"
                          value="1"
                          :state="validateState(v$.isBasementIsDigunakan)"
                        >
                          Digunakan
                        </b-form-radio>
                        <b-col
                          v-if="
                            isBasement === '1' && isBasementIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="basementDigunakan"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-form-input
                              id="basementDigunakan"
                              v-model="v$.basementDigunakan.$model"
                              :state="validateState(v$.basementDigunakan)"
                            />
                            <b-form-invalid-feedback
                              v-for="(error, index) of v$.basementDigunakan
                                .$errors"
                              :key="index"
                            >
                              {{ error.$message }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="v$.isBasementIsDigunakan.$model"
                          value="0"
                          :state="validateState(v$.isBasementIsDigunakan)"
                        >
                          Tidak Digunakan
                        </b-form-radio>
                        <small
                          v-for="(error, index) of v$.isBasementIsDigunakan
                            .$errors"
                          :key="index"
                          class="text-danger"
                        >
                          <span>{{ error.$message }}</span>
                        </small>
                      </b-col>
                      <b-form-radio
                        v-model="v$.isBasement.$model"
                        value="0"
                        :state="validateState(v$.isBasement)"
                      >
                        Tidak Ada Basement
                      </b-form-radio>
                      <small
                        v-for="(error, index) of v$.isBasement.$errors"
                        :key="index"
                        class="text-danger"
                      >
                        <span>{{ error.$message }}</span>
                      </small>
                    </b-form-group>

                    <b-form-group
                      label="d. Halaman / Taman"
                      label-for="isHalamanUtama"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-radio
                        v-model="v$.isHalamanUtama.$model"
                        value="1"
                        :state="validateState(v$.isHalamanUtama)"
                      >
                        Ada (Memiliki Halaman / Utama)
                      </b-form-radio>
                      <b-col
                        v-if="isHalamanUtama === '1'"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-radio
                          v-model="v$.isHalamanUtamaIsDigunakan.$model"
                          value="1"
                          :state="validateState(v$.isHalamanUtamaIsDigunakan)"
                        >
                          Digunakan
                        </b-form-radio>
                        <b-col
                          v-if="
                            isHalamanUtama === '1' &&
                              isHalamanUtamaIsDigunakan === '1'
                          "
                          cols="11"
                          offset-md="1"
                          class="mt-1 pr-0"
                        >
                          <b-form-group
                            label="Digunakan Untuk"
                            label-for="halamanUtamaDigunakan"
                            label-size="lg"
                            label-class="pb-0 pt-0"
                          >
                            <b-form-input
                              id="halamanUtamaDigunakan"
                              v-model="v$.halamanUtamaDigunakan.$model"
                              :state="validateState(v$.halamanUtamaDigunakan)"
                            />
                            <b-form-invalid-feedback
                              v-for="(error, index) of v$.halamanUtamaDigunakan
                                .$errors"
                              :key="index"
                            >
                              {{ error.$message }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-form-radio
                          v-model="v$.isHalamanUtamaIsDigunakan.$model"
                          value="0"
                          :state="validateState(v$.isHalamanUtamaIsDigunakan)"
                        >
                          Tidak Digunakan
                        </b-form-radio>
                        <small
                          v-for="(error, index) of v$.isHalamanUtamaIsDigunakan
                            .$errors"
                          :key="index"
                          class="text-danger"
                        >
                          <span>{{ error.$message }}</span>
                        </small>
                      </b-col>
                      <b-form-radio
                        v-model="v$.isHalamanUtama.$model"
                        value="0"
                        :state="validateState(v$.isHalamanUtama)"
                      >
                        Tidak Ada Halaman / Utama
                      </b-form-radio>
                      <small
                        v-for="(error, index) of v$.isHalamanUtama.$errors"
                        :key="index"
                        class="text-danger"
                      >
                        <span>{{ error.$message }}</span>
                      </small>
                    </b-form-group>
                  </b-col>
                </b-form-group>

                <label
                  for="nilaiStrategisBMD"
                  class="d-block col-form-label-lg pb-0 pt-0"
                >
                  12. Nilai Strategis BMD
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Memiliki nilai strategis apabila memakai satu atau lebih dari kriteria berikut: lokasi mudah diakses kendaraan roda 4, terdapat lahan parkir memadai, lingkungan nyaman dan tersedianya sumber daya"
                  />
                </label>

                <b-form-select
                  id="nilaiStrategisBMD"
                  v-model="v$.nilaiStrategisBMD.$model"
                  :options="dataNilaiStrategisBMD"
                  :state="validateState(v$.nilaiStrategisBMD)"
                />
                <b-form-invalid-feedback
                  v-for="(error, index) of v$.nilaiStrategisBMD.$errors"
                  :key="index"
                >
                  {{ error.$message }}
                </b-form-invalid-feedback>

                <b-col
                  v-if="nilaiStrategisBMD === '1'"
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                >
                  <b-form-checkbox
                    v-model="v$.memilikiNilaiStrategis.$model"
                    value="3"
                    :state="validateState(v$.memilikiNilaiStrategis)"
                  >
                    Lokasi mudah diakses kendaraan roda 4, memiliki jalan dua
                    arah dengan lebar jalan kurang lebih 8m
                    <feather-icon
                      v-b-tooltip.hover
                      icon="AlertCircleIcon"
                      class="text-warning"
                      title="Jalan akses menuju lokasi gedung dan bangunan memiliki luasan yang cukup untuk dilewati kendaraan roda 4 dua arah"
                    />
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="v$.memilikiNilaiStrategis.$model"
                    value="2"
                    :state="validateState(v$.memilikiNilaiStrategis)"
                  >
                    Terdapat lahan parkir yang memadai (tidak pernah kesulitan
                    dalam memarkirkan kendaraan)
                    <feather-icon
                      v-b-tooltip.hover
                      icon="AlertCircleIcon"
                      class="text-warning"
                      title="Gedung dan bangunan memiliki lahan parkir yang bisa menampung minimal 5"
                    />
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="v$.memilikiNilaiStrategis.$model"
                    value="1"
                    :state="validateState(v$.memilikiNilaiStrategis)"
                  >
                    Lingkungan strategis dekat dengan pusat bisnis atau
                    fasilitas publik
                    <feather-icon
                      v-b-tooltip.hover
                      icon="AlertCircleIcon"
                      class="text-warning"
                      title="Gedung dan bangunan berada pada lokasi yang strategis tanpa disertai gangguan berarti. Misalnya, dekat dengan pusat perbelanjaan atau tempat wisata"
                    />
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="v$.memilikiNilaiStrategis.$model"
                    value="0"
                    :state="validateState(v$.memilikiNilaiStrategis)"
                  >
                    Tersedianya sumber daya (listrik, air dan layanan jaringan
                    internet)
                    <feather-icon
                      v-b-tooltip.hover
                      icon="AlertCircleIcon"
                      class="text-warning"
                      title="Tersedianya aliran listrik dengan kerusakan jaringan yang minimal, air mengalir dan/atau terjangkau jaringan provider internet"
                    />
                  </b-form-checkbox>
                  <small
                    v-for="(error, index) of v$.memilikiNilaiStrategis.$errors"
                    :key="index"
                    class="text-danger"
                  >
                    {{ error.$message }}
                  </small>
                </b-col>

                <b-form-group
                  label="13. Penguasaan Fisik"
                  label-for="nilaiStrategisBMD"
                  label-size="lg"
                  label-class="pb-0 pt-1"
                >
                  <b-form-radio
                    v-model="v$.pengamananFisik.$model"
                    value="1"
                    :state="validateState(v$.pengamananFisik)"
                  >
                    Fisik Dikuasai
                  </b-form-radio>
                  <b-col
                    v-if="pengamananFisik === '1'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-radio
                      v-model="v$.fisikDikuasai.$model"
                      value="1"
                      :state="validateState(v$.fisikDikuasai)"
                    >
                      Fisik dikuasai seluruh oleh Pemerintah Provinsi DKI
                      Jakarta
                    </b-form-radio>
                    <b-form-radio
                      v-model="v$.fisikDikuasai.$model"
                      value="0"
                      :state="validateState(v$.fisikDikuasai)"
                    >
                      Fisik dikuasai sebagian oleh pihak lain
                    </b-form-radio>
                    <small
                      v-for="(error, index) of v$.fisikDikuasai.$errors"
                      :key="index"
                      class="text-danger"
                    >
                      {{ error.$message }}
                    </small>
                    <b-col
                      v-if="pengamananFisik === '1' && fisikDikuasai === '0'"
                      cols="11"
                      offset-md="1"
                      class="mt-1 pr-0"
                    >
                      <b-form-group
                        label="Sebutkan"
                        label-for="fisikDikuasaiSebutkan"
                        label-size="lg"
                        label-class="pb-0 pt-0"
                      >
                        <b-form-input
                          id="fisikDikuasaiSebutkan"
                          v-model="v$.fisikDikuasaiSebutkan.$model"
                          :state="validateState(v$.fisikDikuasaiSebutkan)"
                        />
                        <b-form-invalid-feedback
                          v-for="(error, index) of v$.fisikDikuasaiSebutkan
                            .$errors"
                          :key="index"
                        >
                          {{ error.$message }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-col>
                  <b-form-radio
                    v-model="v$.pengamananFisik.$model"
                    value="0"
                    :state="validateState(v$.pengamananFisik)"
                  >
                    Fisik Tidak Dikuasai (dikuasai seluruhnya oleh pihak lain)
                  </b-form-radio>
                  <b-col
                    v-if="pengamananFisik === '0'"
                    cols="11"
                    offset-md="1"
                    class="mt-1 pr-0"
                  >
                    <b-form-group
                      label="Sebutkan"
                      label-for="fisikTidakDikuasaiSebutkan"
                      label-size="lg"
                      label-class="pb-0 pt-0"
                    >
                      <b-form-input
                        id="fisikTidakDikuasaiSebutkan"
                        v-model="v$.fisikTidakDikuasaiSebutkan.$model"
                        :state="validateState(v$.fisikTidakDikuasaiSebutkan)"
                      />
                      <b-form-invalid-feedback
                        v-for="(error, index) of v$.fisikTidakDikuasaiSebutkan
                          .$errors"
                        :key="index"
                      >
                        {{ error.$message }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <small
                    v-for="(error, index) of v$.pengamananFisik.$errors"
                    :key="index"
                    class="text-danger"
                  >
                    {{ error.$message }}
                  </small>
                </b-form-group>

                <label
                  for="sengketaGedungBangunan"
                  class="d-block col-form-label-lg pb-0 pt-0"
                >
                  14. Sengketa Pada Gedung dan Bangunan
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="Gedung dan bangunan bersengketa apabila sudah ada gugatan di pengadilan atas gedung dan bangunan tersebut"
                  />
                </label>
                <b-form-radio
                  v-model="v$.sengketaGedungBangunan.$model"
                  value="1"
                  :state="validateState(v$.sengketaGedungBangunan)"
                >
                  Ada Sengketa
                </b-form-radio>
                <b-form-radio
                  v-model="v$.sengketaGedungBangunan.$model"
                  value="0"
                  :state="validateState(v$.sengketaGedungBangunan)"
                >
                  Tidak Ada Sengketa
                </b-form-radio>
                <small
                  v-for="(error, index) of v$.sengketaGedungBangunan.$errors"
                  :key="index"
                  class="text-danger"
                >
                  {{ error.$message }}
                </small>

                <label
                  for="ketAsetBersejarah"
                  class="d-block col-form-label-lg pb-0 pt-1"
                >
                  15. Keterangan Aset Bersejarah
                  <feather-icon
                    v-b-tooltip.hover
                    icon="AlertCircleIcon"
                    class="text-warning"
                    title="BMD tergolong aset bersejarah apabila memiliki karakteristik sebagai berikut.
                    -Memiliki nilai kultural lingkungan pendidikan dan sejarahnya tidak mungkin secara penuh dilambangkan dengan nilai keuangan berdasarkan harga pasar;
                    -Peraturan dan hukum melarang atau membatasi secara ketat pelepasannya untuk dijual;
                    -Tidak mudah untuk diganti dan nilainya akan terus meningkat selama waktu berjalan walaupun kondisi fisiknya semakin menurun; dan
                    -Sulit untuk mengestimasikan masa manfaatnya terhadap beberapa kasus dapat mencapai ratusan tahun;"
                  />
                </label>
                <b-form-radio
                  v-model="v$.ketAsetBersejarah.$model"
                  value="1"
                  :state="validateState(v$.ketAsetBersejarah)"
                >
                  Ya, BMD merupakan aset bersejarah
                </b-form-radio>
                <b-form-radio
                  v-model="v$.ketAsetBersejarah.$model"
                  value="0"
                  :state="validateState(v$.ketAsetBersejarah)"
                >
                  Tidak, BMD bukan merupakan aset bersejarah
                </b-form-radio>
                <small
                  v-for="(error, index) of v$.ketAsetBersejarah.$errors"
                  :key="index"
                  class="text-danger"
                >
                  {{ error.$message }}
                </small>

                <b-form-group
                  v-if="statusPersetujuanVal === '0'"
                  label="Catatan"
                  label-for="catatan"
                  label-size="lg"
                  label-class="pb-0 pt-0"
                >
                  <label
                    for="catatanValue"
                    class="font-weight-bolder"
                  >{{
                    catatanVal
                  }}</label>
                </b-form-group>

                <b-col
                  cols="12"
                  class="text-right pr-0 pt-2"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                  >
                    <div v-if="isSubmit">
                      <b-spinner small />
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div v-else>
                      Simpan
                    </div>
                  </b-button>
                </b-col>
              </b-overlay>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BRow,
} from 'bootstrap-vue'
import {
  required,
  helpers,
  minValue,
  minLength,
  maxLength,
  decimal,
} from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import {
  ref,
  computed,
  watchEffect,
  watch,
  onUnmounted,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import dataInformasi from '@/composables/dataInformasi'
import { setInputIntOnly } from '@/libs/helper'
import master from '@/composables/master'
import V1KodeBarang from '@/views/dataInformasi/component/field/V1KodeBarang'
import V2Ukuran from '@/views/dataInformasi/component/field/V2Ukuran'
import V3SpesifikasiBarang from '@/views/dataInformasi/component/field/V3SpesifikasiBarang'
import V4Alamat from '@/views/dataInformasi/component/field/V4Alamat'
import V5GedungBangunanDiatasTanahMilik from '@/views/dataInformasi/component/field/V5GedungBangunanDiatasTanahMilik'
import V6IndikasiTercatatGanda from '@/views/dataInformasi/component/field/V6IndikasiTercatatGanda'
import V7IndikasiTercatatGabungan from '@/views/dataInformasi/component/field/V7IndikasiTercatatGabungan'
import ToastificationContent from '@/views/dataInformasi/component/toast/ToastificationContent.vue'

export default {
  setup(props, context) {
    const g = context.root

    const isSubmit = ref(false)

    const tahunNow = ref(moment().format('YYYY'))
    const isShowData = ref(false)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))
    const defaultKolok = ref({ text: '-- Pilih Salah Satu --', value: null })
    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      defaultKolok.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
    }

    // form name
    const kesesuaianKodeBarang = ref('')
    const kodeBarangSeharusnya = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const kibSeharusnya = ref(null)
    const namaBarangSeharusnya = ref('')
    const kesesuaianUkuran = ref('')
    const ukuranSeharusnya = ref('')
    const isDisableUkuran = ref(false)
    const satuanSeharusnya = ref('')
    const namaSpesifikasiBarang = ref('')
    const isBertingkat = ref('')
    const bertingkatSeharusnya = ref(null)
    const isLantaiDigunakan = ref(null)
    const jumlahSeluruhLantai = ref('')
    const jumlahLantaiDigunakan = ref('')
    const jumlahLantaiTidakDigunakan = ref('')
    const kesesuaianBahan = ref('')
    const bahanSeharusnya = ref(null)
    const skPenggunaan = ref('')
    const nomorSkPenggunaan = ref('')
    const tahunSkPenggunaan = ref('')
    const penggunaan = ref(null)
    const digunakanBersama = ref([])
    // const digunakanUntuk = ref('')
    // const pdUkpd = ref({text: '-- Pilih Salah Satu --', value: null})
    const pdUkpd = ref([
      {
        value: { text: '-- Pilih Salah Satu --', value: null },
      },
    ])
    const digunakanUntuk = ref([
      {
        value: '',
      },
    ])
    // const pemanfaat = ref(null)
    const pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    // var namaPemanfaat = ref('')
    // var dasarPenggunaan = ref('')
    // var dasarPenggunaanTipe = ref('')
    const gedungBangunanTanahMilik = ref(null)
    const isGedungBangunanTanahMilikTercatat = ref(null)
    const gedungBangunanTanahMilikPdUkpd = ref(defaultKolok.value)
    const gedungBangunanTanahMilikKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikKeterangan = ref('')
    const gedungBangunanTanahMilikSebutkan = ref('')
    const kesesuaianAlamat = ref('0')
    const provinsi = ref(null)
    const kabKota = ref(null)
    const kecamatan = ref(null)
    const kelurahan = ref(null)
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const kodePos = ref('')
    const isIndikasiGanda = ref('')
    const indikasiGandaDengan = ref(null)
    const isLoadIndikasiGandaPdUkpd = ref(false)
    const indikasiGandaSebutkan = ref('')
    const indikasiGandaPdUkpd = ref(defaultKolok.value)
    const indikasiGandaKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const indikasiGandaRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const isLoadIndikasiGandaRegister = ref(false)
    const indikasiGabungan = ref(null)
    const indikasiGabunganKeterangan = ref(null)
    const isAtapBeton = ref(null)
    const isAtapBetonIsDigunakan = ref(null)
    const atapBetonDigunakan = ref('')
    const isBasement = ref(null)
    const isBasementIsDigunakan = ref(null)
    const basementDigunakan = ref('')
    const isHalamanUtama = ref(null)
    const isHalamanUtamaIsDigunakan = ref(null)
    const halamanUtamaDigunakan = ref('')
    const nilaiStrategisBMD = ref(null)
    const memilikiNilaiStrategis = ref([])
    const pengamananFisik = ref(null)
    const fisikDikuasai = ref(null)
    const fisikDikuasaiSebutkan = ref('')
    const fisikTidakDikuasaiSebutkan = ref(null)
    const sengketaGedungBangunan = ref(null)
    const ketAsetBersejarah = ref(null)

    const dataKobar = ref([])
    const dataIndikasiGandaKobar = ref([])
    const dataBertingkatSeharusnya = ref([])
    const dataBahanSeharusnya = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '0', text: 'Bukan Beton' },
      { value: '1', text: 'Beton' },
      { value: '2', text: 'Campuran' },
    ])
    const dataPenggunaan = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Tidak Digunakan' },
      { value: '2', text: 'Digunakan Sendiri Seluruhnya Oleh PD/UKPD' },
      { value: '3', text: 'Digunakan Seluruhnya Oleh PD/UKPD Lain' },
      {
        value: '4',
        text: 'Digunakan Bersama Oleh PD/UKPD Lain Dan/Atau Pihak Lain',
      },
      { value: '5', text: 'Digunakan Instansi/Pihak Lain Seluruhnya' },
    ])
    const dataPdUkpd = ref([])
    const dataPemanfaat = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Pemerintah Pusat' },
      { value: '2', text: 'Pemerintah Daerah Lainnya' },
      { value: '3', text: 'Pihak Lain Selain Pemerintah' },
    ])
    const dataIndikasiGandaDengan = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '1', text: 'Pemerintah Pusat' },
      { value: '2', text: 'Pemerintah Daerah Lain' },
      { value: '3', text: 'PD/UKPD' },
    ])
    const dataIndikasiGabungan = ref([
      { value: null, text: '-- Pilih Salah Satu --' },
      { value: '0', text: 'Tidak Tercatat Gabungan' },
      { value: '1', text: 'Terindikasi Gabungan' },
    ])
    const dataIndikasiGandaPdUkpd = ref([])
    const dataIndikasiGandaRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataGedungBangunanTanahMilikRegister = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataGedungBangunanTanahMilikKobar = ref([
      { text: '-- Pilih Salah Satu --', value: null },
    ])
    const dataNilaiStrategisBMD = ref([
      { text: '-- Pilih Salah Satu --', value: null },
      { value: '0', text: 'Tidak Memiliki Nilai Strategis' },
      { value: '1', text: 'Memiliki Nilai Strategis' },
    ])

    const isShowInfo = ref(false)

    watch(isShowInfo, () => {
      if (isShowInfo.value) {
        g.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Perhatian',
              icon: 'BellIcon',
              text: 'Ada beberapa perubahan terkait form yg harus diisi pada mobile',
              variant: 'warning',
            },
          },
          {
            timeout: false,
            position: 'top-center',
          },
        )
      }
    })

    onUnmounted(() => {
      g.$toast.clear()
    })

    const getPdUkpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunNow.value,
        cari: searchPdUpd,
      }
      const resPdUkpd = await master.getPdUpd(g, params)
      resPdUkpd.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataPdUkpd.value = resPdUkpd
      dataIndikasiGandaPdUkpd.value = resPdUkpd
    }

    getPdUkpd()

    watchEffect(() => {
      isShowData.value = props.isShowUbahVal
      if (props.kesesuaianBahanVal === '0' || props.kesesuaianBahanVal === '1') kesesuaianBahan.value = props.kesesuaianBahanVal
      else if (!props.jenisBetonVal) kesesuaianBahan.value = '0'
      else kesesuaianBahan.value = ''
      kodeBarangSeharusnya.value = props.kodeBarangSeharusnyaVal
      satuanSeharusnya.value = props.satuanSeharusnyaVal

      kesesuaianKodeBarang.value = props.kesesuaianKodeBarangVal
      kibSeharusnya.value = props.kibSeharusnyaVal
      namaBarangSeharusnya.value = props.namaBarangSeharusnyaVal
      kesesuaianUkuran.value = props.kesesuaianUkuranVal
      ukuranSeharusnya.value = props.ukuranSeharusnyaVal
      namaSpesifikasiBarang.value = props.namaSpesifikasiBarangVal
      isBertingkat.value = props.isBertingkatVal
      bertingkatSeharusnya.value = props.bertingkatSeharusnyaVal
      jumlahSeluruhLantai.value = props.jumlahSeluruhLantaiVal
      isLantaiDigunakan.value = props.isLantaiDigunakanVal
      jumlahLantaiTidakDigunakan.value = props.jumlahLantaiTidakDigunakanVal
      jumlahLantaiDigunakan.value = props.jumlahLantaiDigunakanVal
      bahanSeharusnya.value = props.bahanSeharusnyaVal
      skPenggunaan.value = props.skPenggunaanVal
      nomorSkPenggunaan.value = props.nomorSkPenggunaanVal
      tahunSkPenggunaan.value = props.tahunSkPenggunaanVal
      penggunaan.value = props.penggunaanVal
      gedungBangunanTanahMilik.value = props.gedungBangunanTanahMilikVal
      isGedungBangunanTanahMilikTercatat.value = props.isGedungBangunanTanahMilikTercatatVal
      gedungBangunanTanahMilikKeterangan.value = props.gedungBangunanTanahMilikKeteranganVal
      gedungBangunanTanahMilikPdUkpd.value = props.gedungBangunanTanahMilikPdUkpdVal
      gedungBangunanTanahMilikKobar.value = props.gedungBangunanTanahMilikKobarVal
      gedungBangunanTanahMilikRegister.value = props.gedungBangunanTanahMilikRegisterVal
      gedungBangunanTanahMilikSebutkan.value = props.gedungBangunanTanahMilikSebutkanVal
      provinsi.value = props.provinsiVal
      kecamatan.value = props.kecamatanVal
      kelurahan.value = props.kelurahanVal
      jalan.value = props.jalanVal
      noAlamat.value = props.noAlamatVal
      rt.value = props.rtVal
      rw.value = props.rwVal
      kodePos.value = props.kodePosVal
      isIndikasiGanda.value = props.isIndikasiGandaVal
      indikasiGandaDengan.value = props.indikasiGandaDenganVal
      indikasiGandaSebutkan.value = props.indikasiGandaSebutkanVal
      indikasiGandaPdUkpd.value = props.indikasiGandaPdUkpdVal
      indikasiGandaKobar.value = props.indikasiGandaKobarVal
      indikasiGandaRegister.value = props.indikasiGandaRegisterVal
      indikasiGabungan.value = props.indikasiGabunganVal
      indikasiGabunganKeterangan.value = props.indikasiGabunganKeteranganVal
      isAtapBeton.value = props.isAtapBetonVal
      isAtapBetonIsDigunakan.value = props.isAtapBetonIsDigunakanVal
      atapBetonDigunakan.value = props.atapBetonDigunakanVal
      isBasement.value = props.isBasementVal
      isBasementIsDigunakan.value = props.isBasementIsDigunakanVal
      basementDigunakan.value = props.basementDigunakanVal
      isHalamanUtama.value = props.isHalamanUtamaVal
      isHalamanUtamaIsDigunakan.value = props.isHalamanUtamaIsDigunakanVal
      halamanUtamaDigunakan.value = props.halamanUtamaDigunakanVal
      nilaiStrategisBMD.value = props.nilaiStrategisBMDVal
      memilikiNilaiStrategis.value = props.memilikiNilaiStrategisVal
      pengamananFisik.value = props.pengamananFisikVal
      fisikDikuasai.value = props.fisikDikuasaiVal
      fisikDikuasaiSebutkan.value = props.fisikDikuasaiSebutkanVal
      fisikTidakDikuasaiSebutkan.value = props.fisikTidakDikuasaiSebutkanVal
      sengketaGedungBangunan.value = props.sengketaGedungBangunanVal
      ketAsetBersejarah.value = props.ketAsetBersejarahVal

      kabKota.value = props.kabKotaVal
    })

    watchEffect(() => {
      digunakanUntuk.value = props.digunakanUntukVal
      pdUkpd.value = props.pdUkpdVal
      pemanfaat.value = props.pemanfaatVal
    })

    watchEffect(() => {
      digunakanBersama.value = props.digunakanBersamaVal
    })

    const checkField = (val, compareWith) => {
      if (!val && compareWith) return false

      return true
    }

    const checkSelectCostum = (val, compareWith) => {
      if (!val.value && compareWith) return false

      return true
    }

    const checkLantai = (val, compareWith) => {
      if (parseInt(val, 10) > parseInt(jumlahSeluruhLantai.value, 10) && compareWith) {
        return false
      }

      return true
    }

    // validation
    const requiredMsg = 'tidak boleh kosong'
    const $externalResults = ref({})
    const rules = computed(() => ({
      kesesuaianKodeBarang: {
        required: helpers.withMessage(
          `Kesesuaian Kode Barang ${requiredMsg}`,
          required,
        ),
      },
      kibSeharusnya: {
        checkField: helpers.withMessage(
          `Kesesuaian KIB ${requiredMsg}`,
          val => checkField(val, kesesuaianKodeBarang.value === '0'),
        ),
      },
      kodeBarangSeharusnya: {
        checkSelectCostum: helpers.withMessage(
          'Kode Barang Yang Seharusnya Harus di Isi Jika Tidak Sesuai',
          val => checkSelectCostum(val, kesesuaianKodeBarang.value === '0'),
        ),
      },
      kesesuaianUkuran: {
        required: helpers.withMessage(
          `Kesesuaian Ukuran ${requiredMsg}`,
          required,
        ),
      },
      ukuranSeharusnya: {
        checkField: helpers.withMessage(
          'Ukuran Seharusnya Harus di Isi Jika Tidak Sesuai',
          val => checkField(val, kesesuaianUkuran.value === '0'),
        ),
        decimal: helpers.withMessage(
          'Ukuran Seharusnya Harus di Isi Angka',
          decimal,
        ),
      },
      namaSpesifikasiBarang: {
        required: helpers.withMessage(
          `Nama Spesifikasi Barang ${requiredMsg}`,
          required,
        ),
      },
      isBertingkat: {
        required: helpers.withMessage(`Bertingkat ${requiredMsg}`, required),
      },
      bertingkatSeharusnya: {
        checkField: val => checkField(val, isBertingkat.value === '1'),
      },
      isLantaiDigunakan: {
        required: helpers.withMessage(
          `Lantai Digunakan ${requiredMsg}`,
          required,
        ),
      },
      jumlahSeluruhLantai: {
        checkField: val => checkField(val, isLantaiDigunakan.value === '1'),
      },
      jumlahLantaiDigunakan: {
        checkField: val => checkField(val, isLantaiDigunakan.value === '1'),
      },
      jumlahLantaiTidakDigunakan: {
        checkField: val => checkField(val, isLantaiDigunakan.value === '1'),
        checkLantai: helpers.withMessage(
          'Jumlah Lantai Yang Tidak Digunakan Harus Lebih Kecil Dari Jumlah Seluruh Lantai',
          val => checkLantai(val, isLantaiDigunakan.value === '1'),
        ),
        minValue: helpers.withMessage(
          'Jumlah Lantai Yang Tidak Digunakan Harus Lebih Besar Dari 0',
          minValue(1),
        ),
      },
      // kesesuaianBahan: {
      //     required: helpers.withMessage('Kesesuaian Bahan '+requiredMsg, required)
      // },
      // bahanSeharusnya: {
      //     checkField: (val) => checkField(val, kesesuaianBahan.value === '0')
      // },
      skPenggunaan: {
        required: helpers.withMessage(`SK Penggunaan ${requiredMsg}`, required),
      },
      nomorSkPenggunaan: {
        checkField: val => checkField(val, skPenggunaan.value === '1'),
      },
      tahunSkPenggunaan: {
        checkField: val => checkField(val, skPenggunaan.value === '1'),
      },
      penggunaan: {
        required: helpers.withMessage(`Penggunaan ${requiredMsg}`, required),
      },
      // digunakanUntuk: {
      //     checkField: (val) => checkField(val, penggunaan.value === '2' || penggunaan.value === '3' || penggunaan.value === '4')
      // },
      // pdUkpd: {
      //     checkSelectCostum: (val) => checkSelectCostum(val, penggunaan.value === '3' || penggunaan.value === '4'),
      // },
      pdUkpd: {
        $each: helpers.forEach({
          value: {
            checkSelectCostum: val => checkSelectCostum(
              val,
              penggunaan.value === '3'
                  || (penggunaan.value === '4'
                    && digunakanBersama.value.includes('1')),
            ),
          },
        }),
      },
      digunakanUntuk: {
        $each: helpers.forEach({
          value: {
            checkField: val => checkField(
              val,
              penggunaan.value === '2'
                  || penggunaan.value === '3'
                  || (penggunaan.value === '4'
                    && digunakanBersama.value.includes('1')),
            ),
          },
        }),
      },
      // pemanfaat: {
      //     checkField: (val) => checkField(val, penggunaan.value === '4' || penggunaan.value === '5')
      // },
      pemanfaat: {
        $each: helpers.forEach({
          value: {
            checkField: val => checkField(
              val,
              (penggunaan.value === '4'
                  && digunakanBersama.value.includes('0'))
                  || penggunaan.value === '5',
            ),
          },
          namaPemanfaat: {
            checkField: val => checkField(
              val,
              (penggunaan.value === '4'
                  && digunakanBersama.value.includes('0'))
                  || penggunaan.value === '5',
            ),
          },
          dasarPenggunaan: {
            checkField: val => checkField(
              val,
              (penggunaan.value === '4'
                  && digunakanBersama.value.includes('0'))
                  || penggunaan.value === '5',
            ),
          },
          dasarPenggunaanTipe: {
            checkField: (val, valueObject) => checkField(
              val,
              ((penggunaan.value === '4'
                  && digunakanBersama.value.includes('0'))
                  || penggunaan.value === '5')
                  && valueObject.value === '3'
                  && valueObject.dasarPenggunaan === '1',
            ),
          },
        }),
      },
      // namaPemanfaat: {
      //     checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
      // },
      // dasarPenggunaan: {
      //     checkField: (val) => checkField(val, pemanfaat.value === '1' || pemanfaat.value === '2' || pemanfaat.value === '3')
      // },
      // dasarPenggunaanTipe: {
      //     checkField: (val) => checkField(val, pemanfaat.value === '3' && dasarPenggunaan.value == '1')
      // },
      gedungBangunanTanahMilik: {
        required: helpers.withMessage(
          `Gedung dan Bangunan di Atas Tanah Milik ${requiredMsg}`,
          required,
        ),
      },
      isGedungBangunanTanahMilikTercatat: {
        checkField: helpers.withMessage(
          'Harus Diisi Jika Pemerintah Daerah Provinsi DKI Jakarta',
          val => checkField(val, gedungBangunanTanahMilik.value === '1'),
        ),
      },
      gedungBangunanTanahMilikPdUkpd: {
        checkSelectCostum: val => checkSelectCostum(
          val,
          gedungBangunanTanahMilik.value === '1'
              && isGedungBangunanTanahMilikTercatat.value == '1',
        ),
      },
      gedungBangunanTanahMilikKobar: {
        checkSelectCostum: helpers.withMessage(
          'Kode Barang Harus di Isi Jika Sudah Tercatat',
          val => checkSelectCostum(
            val,
            gedungBangunanTanahMilik.value === '1'
                && isGedungBangunanTanahMilikTercatat.value == '1',
          ),
        ),
      },
      gedungBangunanTanahMilikRegister: {
        checkSelectCostum: helpers.withMessage(
          'Register Harus di Isi Jika Sudah Tercatat',
          val => checkSelectCostum(
            val,
            gedungBangunanTanahMilik.value === '1'
                && isGedungBangunanTanahMilikTercatat.value == '1',
          ),
        ),
      },
      gedungBangunanTanahMilikKeterangan: {
        checkField: helpers.withMessage(
          'Keterangan Harus Diisi Jika Belum Tercatat',
          val => checkField(
            val,
            gedungBangunanTanahMilik.value === '1'
                && isGedungBangunanTanahMilikTercatat.value == '0',
          ),
        ),
      },
      gedungBangunanTanahMilikSebutkan: {
        checkField: helpers.withMessage('Sebutkan Harus di Isi', val => checkField(
          val,
          gedungBangunanTanahMilik.value === '2'
              || gedungBangunanTanahMilik.value === '3'
              || gedungBangunanTanahMilik.value === '4',
        )),
      },
      kesesuaianAlamat: {
        // required: helpers.withMessage('Gedung dan Bangunan di Atas Tanah Milik '+requiredMsg, required)
      },
      provinsi: {
        checkField: helpers.withMessage(
          'Provinsi Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
      },
      kabKota: {
        checkField: helpers.withMessage(
          'Kabupaten/Kota Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
      },
      kecamatan: {
        checkField: helpers.withMessage(
          'Kecamatan Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
      },
      kelurahan: {
        checkField: helpers.withMessage(
          'Kelurahan Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
      },
      jalan: {
        checkField: helpers.withMessage(
          'Jalan Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
      },
      noAlamat: {
        checkField: val => checkField(val),
      },
      rt: {
        checkField: helpers.withMessage(
          'RT Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
        minLength: helpers.withMessage('Harus 3 Digit', minLength(3)),
        maxLength: helpers.withMessage('Harus 3 Digit', maxLength(3)),
      },
      rw: {
        checkField: helpers.withMessage(
          'RW Harus di Isi Jika Tidak Sesuai Dengan Data Lama',
          val => checkField(val, true),
        ),
        minLength: helpers.withMessage('Harus 3 Digit', minLength(3)),
        maxLength: helpers.withMessage('Harus 3 Digit', maxLength(3)),
      },
      kodePos: {
        // checkField: (val) => checkField(val, true),
      },
      isIndikasiGanda: {
        required: helpers.withMessage(
          `Indikasi Tercatat Ganda ${requiredMsg}`,
          required,
        ),
      },
      indikasiGandaDengan: {
        checkField: helpers.withMessage(
          'Indikasi Ganda Harus di Isi Jika Terindikasi Tercatat Ganda',
          val => checkField(val, isIndikasiGanda.value === '1'),
        ),
      },
      indikasiGandaSebutkan: {
        checkField: helpers.withMessage(
          'Sebutkan Harus di Isi Jika Terindikasi Tercatat Ganda Dengan Pemerintah Pusat Atau Pemerintah Daerah Lain',
          val => checkField(
            val,
            isIndikasiGanda.value === '1'
                && (indikasiGandaDengan.value === '1'
                  || indikasiGandaDengan.value === '2'),
          ),
        ),
      },
      indikasiGandaPdUkpd: {
        checkSelectCostum: helpers.withMessage(
          'PD/UKPD Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD',
          val => checkSelectCostum(
            val,
            isIndikasiGanda.value === '1' && indikasiGandaDengan.value === '3',
          ),
        ),
      },
      indikasiGandaKobar: {
        checkSelectCostum: helpers.withMessage(
          'Kode Barang Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD',
          val => checkSelectCostum(
            val,
            isIndikasiGanda.value === '1' && indikasiGandaDengan.value === '3',
          ),
        ),
      },
      indikasiGandaRegister: {
        checkSelectCostum: helpers.withMessage(
          'Register Harus di Isi Jika Terindikasi Tercatat Ganda Dengan PD/UKPD',
          val => checkSelectCostum(
            val,
            isIndikasiGanda.value === '1' && indikasiGandaDengan.value === '3',
          ),
        ),
      },
      indikasiGabungan: {
        required: helpers.withMessage(
          `Indikasi Tercatat Gabungan (Gelondongan) ${requiredMsg}`,
          required,
        ),
      },
      indikasiGabunganKeterangan:
        indikasiGabungan.value == 1
          ? {
            required: helpers.withMessage(
              'Keterangan Harus Diisi Jika Terindikasi Tercatat Gabungan (Gelondongan)',
              required,
            ),
          }
          : {},
      isAtapBeton: {
        required: helpers.withMessage(`Atap Beton ${requiredMsg}`, required),
      },
      isAtapBetonIsDigunakan:
        isAtapBeton.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Atap Beton ${requiredMsg}`,
              required,
            ),
          }
          : {},
      atapBetonDigunakan:
        isAtapBeton.value === '1' && isAtapBetonIsDigunakan.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Untuk ${requiredMsg}`,
              required,
            ),
          }
          : {},
      isBasement: {
        required: helpers.withMessage(`Basement ${requiredMsg}`, required),
      },
      isBasementIsDigunakan:
        isBasement.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Basement ${requiredMsg}`,
              required,
            ),
          }
          : {},
      basementDigunakan:
        isBasement.value === '1' && isBasementIsDigunakan.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Untuk ${requiredMsg}`,
              required,
            ),
          }
          : {},
      isHalamanUtama: {
        required: helpers.withMessage(
          `Halaman / Utama ${requiredMsg}`,
          required,
        ),
      },
      isHalamanUtamaIsDigunakan:
        isHalamanUtama.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Halaman / Utama ${requiredMsg}`,
              required,
            ),
          }
          : {},
      halamanUtamaDigunakan:
        isHalamanUtama.value === '1' && isHalamanUtamaIsDigunakan.value === '1'
          ? {
            required: helpers.withMessage(
              `Digunakan Untuk ${requiredMsg}`,
              required,
            ),
          }
          : {},
      nilaiStrategisBMD: {
        required: helpers.withMessage(
          `Nilai Strategis BMD ${requiredMsg}`,
          required,
        ),
      },
      memilikiNilaiStrategis:
        nilaiStrategisBMD.value === '1'
          ? {
            required: helpers.withMessage(
              `Detail Memiliki Nilai Strategis ${requiredMsg}`,
              required,
            ),
          }
          : {},
      pengamananFisik: {
        required: helpers.withMessage(
          `Pengamanan Fisik ${requiredMsg}`,
          required,
        ),
      },
      fisikDikuasai:
        pengamananFisik.value === '1'
          ? {
            required: helpers.withMessage(
              `Fisik Dikuasai ${requiredMsg}`,
              required,
            ),
          }
          : {},
      fisikDikuasaiSebutkan:
        pengamananFisik.value === '1' && fisikDikuasai.value === '0'
          ? {
            required: helpers.withMessage(
              `Sebutkan ${requiredMsg}`,
              required,
            ),
          }
          : {},
      fisikTidakDikuasaiSebutkan:
        pengamananFisik.value === '0'
          ? {
            required: helpers.withMessage(
              `Sebutkan ${requiredMsg}`,
              required,
            ),
          }
          : {},
      sengketaGedungBangunan: {
        required: helpers.withMessage(
          `Sengketa Pada Gedung dan Bangunan ${requiredMsg}`,
          required,
        ),
      },
      ketAsetBersejarah: {
        required: helpers.withMessage(
          `Keterangan Aset Bersejarah ${requiredMsg}`,
          required,
        ),
      },
    }))

    const v$ = useVuelidate(
      rules,
      {
        kesesuaianKodeBarang,
        kodeBarangSeharusnya,
        kesesuaianUkuran,
        ukuranSeharusnya,
        namaSpesifikasiBarang,
        isBertingkat,
        bertingkatSeharusnya,
        isLantaiDigunakan,
        jumlahSeluruhLantai,
        jumlahLantaiDigunakan,
        jumlahLantaiTidakDigunakan,
        skPenggunaan,
        nomorSkPenggunaan,
        tahunSkPenggunaan,
        penggunaan,
        digunakanUntuk,
        pdUkpd,
        pemanfaat,
        gedungBangunanTanahMilik,
        isGedungBangunanTanahMilikTercatat,
        gedungBangunanTanahMilikPdUkpd,
        gedungBangunanTanahMilikKobar,
        gedungBangunanTanahMilikRegister,
        gedungBangunanTanahMilikKeterangan,
        gedungBangunanTanahMilikSebutkan,
        kesesuaianAlamat,
        provinsi,
        kabKota,
        kecamatan,
        kelurahan,
        jalan,
        noAlamat,
        rt,
        rw,
        kodePos,
        isIndikasiGanda,
        indikasiGandaDengan,
        indikasiGandaSebutkan,
        indikasiGandaPdUkpd,
        indikasiGandaKobar,
        indikasiGandaRegister,
        kibSeharusnya,
        indikasiGabungan,
        indikasiGabunganKeterangan,
        isAtapBeton,
        isAtapBetonIsDigunakan,
        atapBetonDigunakan,
        isBasement,
        isBasementIsDigunakan,
        basementDigunakan,
        isHalamanUtama,
        isHalamanUtamaIsDigunakan,
        halamanUtamaDigunakan,
        nilaiStrategisBMD,
        memilikiNilaiStrategis,
        pengamananFisik,
        fisikDikuasai,
        fisikDikuasaiSebutkan,
        fisikTidakDikuasaiSebutkan,
        sengketaGedungBangunan,
        ketAsetBersejarah,
      },
      { $externalResults, $autoDirty: true },
    )

    const submitForm = async () => {
      isSubmit.value = true
      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      // jika error validasi
      console.log(isFormCorrect)
      console.log(v$.value)
      if (!isFormCorrect) {
        isSubmit.value = false
        return
      }

      const data = {
        id: props.id,
        di_m_kobar: kesesuaianKodeBarang.value,
        di_m_ukuran: kesesuaianUkuran.value,
        di_nm_spesifikasi_barang: namaSpesifikasiBarang.value,
        di_m_alamat: kesesuaianAlamat.value,
        di_kd_prop: provinsi.value,
        di_kd_rayon: kabKota.value,
        di_kd_kec: kecamatan.value,
        di_kd_kel: kelurahan.value,
        di_jalan: jalan.value,
        di_no_jalan: noAlamat.value,
        di_rt: rt.value,
        di_rw: rw.value,
        di_kodepos: kodePos.value,
        di_gedung_bangunan_diatas_tanah_milik: gedungBangunanTanahMilik.value,
        di_indikasi_ganda: isIndikasiGanda.value,
        di_indikasi_gabungan: indikasiGabungan.value,
        di_m_sk_penggunaan: skPenggunaan.value,
        di_penggunaan: penggunaan.value,
        di_m_bertingkat: isBertingkat.value,
        di_m_lantai_tdk: isLantaiDigunakan.value,
        di_pp_lt: isLantaiDigunakan.value,
        di_pp_at_ada: isAtapBeton.value,
        di_pp_at_ada_digunakan: isAtapBetonIsDigunakan.value,
        di_pp_at_ada_digunakan_oleh: atapBetonDigunakan.value,
        di_pp_bm_ada: isBasement.value,
        di_pp_bm_ada_digunakan: isBasementIsDigunakan.value,
        di_pp_bm_ada_digunakan_oleh: basementDigunakan.value,
        di_pp_ht_ada: isHalamanUtama.value,
        di_pp_ht_ada_digunakan: isHalamanUtamaIsDigunakan.value,
        di_pp_ht_ada_digunakan_oleh: halamanUtamaDigunakan.value,
        di_nilai_stragtegis: nilaiStrategisBMD.value,
        di_nilai_stragtegis_child: memilikiNilaiStrategis.value,
        di_pengamanan_fisik: pengamananFisik.value,
        di_sengketa: sengketaGedungBangunan.value,
        di_aset_bersejarah: ketAsetBersejarah.value,
      }

      if (pengamananFisik.value === '1') {
        data.di_pengamanan_fisik_child = fisikDikuasai.value
        data.di_pengamanan_fisik_note = fisikDikuasaiSebutkan.value
      } else data.di_pengamanan_fisik_note = fisikTidakDikuasaiSebutkan.value

      if (kesesuaianKodeBarang.value === '0') {
        data.di_m_kobar_a = kodeBarangSeharusnya.value.value
        data.di_m_nabar_a = namaBarangSeharusnya.value
        data.di_m_kobar_kib = kibSeharusnya.value
      }

      if (kesesuaianUkuran.value === '0') data.di_m_ukuran_a = ukuranSeharusnya.value

      if (indikasiGabungan.value == 1) data.di_indikasi_gabungan_keterangan = indikasiGabunganKeterangan.value

      if (isLantaiDigunakan.value === '1') {
        data.di_m_lantai_tdk_all = jumlahSeluruhLantai.value
        data.di_m_lantai_tdk_use = jumlahLantaiDigunakan.value
        data.di_m_lantai_tdk_not = jumlahLantaiTidakDigunakan.value

        data.di_pp_lt_jml = jumlahSeluruhLantai.value
        data.di_pp_lt_digunakan = jumlahLantaiDigunakan.value
        data.di_pp_lt_tidak_digunakan = jumlahLantaiTidakDigunakan.value
      }

      if (skPenggunaan.value === '1') {
        data.di_sk_penggunaan_no = nomorSkPenggunaan.value
        data.di_sk_penggunaan_tahun = tahunSkPenggunaan.value
      }

      if (penggunaan.value === '2' || penggunaan.value === '3') data.di_penggunaan_untuk = [digunakanUntuk.value[0].value]

      if (penggunaan.value === '3') data.di_penggunaan_opd = [pdUkpd.value[0].value.value]

      if (penggunaan.value === '4') {
        if (digunakanBersama.value.includes('1')) {
          data.di_penggunaan_opd = pdUkpd.value.map(item => item.value.value)
          data.di_penggunaan_untuk = digunakanUntuk.value.map(
            item => item.value,
          )
        }

        if (digunakanBersama.value.includes('0')) {
          const listPemanfaat = []
          const listNamaPemanfaat = []
          const listDasarPenggunaan = []
          const listDasarPenggunaanTipe = []

          for (let i = 0; i < pemanfaat.value.length; i += 1) {
            const {
              value,
              namaPemanfaat,
              dasarPenggunaan,
              dasarPenggunaanTipe,
            } = pemanfaat.value[i]

            listPemanfaat.push(value)
            listNamaPemanfaat.push(namaPemanfaat)
            listDasarPenggunaan.push(dasarPenggunaan)
            listDasarPenggunaanTipe.push(dasarPenggunaanTipe ?? null)
          }

          data.di_penggunaan_pemanfaat = listPemanfaat
          data.di_penggunaan_pemanfaat_nama = listNamaPemanfaat
          data.di_penggunaan_pemanfaat_dasar = listDasarPenggunaan
          data.di_penggunaan_pemanfaat_dasar_type = listDasarPenggunaanTipe
        }
      }

      if (penggunaan.value === '5') {
        const listPemanfaat = []
        const listNamaPemanfaat = []
        const listDasarPenggunaan = []
        const listDasarPenggunaanTipe = []

        for (let i = 0; i < pemanfaat.value.length; i += 1) {
          const {
            value, namaPemanfaat, dasarPenggunaan, dasarPenggunaanTipe,
          } = pemanfaat.value[i]

          listPemanfaat.push(value)
          listNamaPemanfaat.push(namaPemanfaat)
          listDasarPenggunaan.push(dasarPenggunaan)
          listDasarPenggunaanTipe.push(dasarPenggunaanTipe ?? null)
        }

        data.di_penggunaan_pemanfaat = listPemanfaat
        data.di_penggunaan_pemanfaat_nama = listNamaPemanfaat
        data.di_penggunaan_pemanfaat_dasar = listDasarPenggunaan
        data.di_penggunaan_pemanfaat_dasar_type = listDasarPenggunaanTipe
      }

      if (isBertingkat.value === '1') data.di_m_bertingkat_a = bertingkatSeharusnya.value

      if (gedungBangunanTanahMilik.value === '1') {
        data.di_gedung_bangunan_diatas_tanah_milik_tercatat = isGedungBangunanTanahMilikTercatat.value

        if (isGedungBangunanTanahMilikTercatat.value == 1) {
          data.di_gedung_bangunan_diatas_tanah_milik_opd = gedungBangunanTanahMilikPdUkpd.value.value
          data.di_gedung_bangunan_diatas_tanah_milik_kobar = gedungBangunanTanahMilikKobar.value.value
          data.di_gedung_bangunan_diatas_tanah_milik_noreg = gedungBangunanTanahMilikRegister.value.value
        } else data.di_gedung_bangunan_diatas_tanah_milik_sebut = gedungBangunanTanahMilikKeterangan.value
      } else if (
        gedungBangunanTanahMilik.value === '2'
        || gedungBangunanTanahMilik.value === '3'
        || gedungBangunanTanahMilik.value === '4'
      ) data.di_gedung_bangunan_diatas_tanah_milik_sebut = gedungBangunanTanahMilikSebutkan.value

      if (isIndikasiGanda.value === '1') {
        data.di_indikasi_ganda_dengan = indikasiGandaDengan.value

        if (
          indikasiGandaDengan.value === '1'
          || indikasiGandaDengan.value === '2'
        ) data.di_indikasi_ganda_sebutkan = indikasiGandaSebutkan.value
        else if (indikasiGandaDengan.value === '3') {
          data.di_indikasi_ganda_opd = indikasiGandaPdUkpd.value.value
          data.di_indikasi_ganda_kobar = indikasiGandaKobar.value.value
          data.di_indikasi_ganda_register = indikasiGandaRegister.value.value
        }
      }

      await dataInformasi.submit(g, data)
      isSubmit.value = false
    }

    const getTingkat = async () => {
      const resGetTingkat = await master.getTingkat(g)

      resGetTingkat.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataBertingkatSeharusnya.value = resGetTingkat
    }

    const getKobarTemp = async params => {
      let resKobar = await master.getKobar(g, params)

      resKobar = resKobar.rows.map(data => ({
        text: `${data.kode} :: ${data.nama}`,
        value: data.kode,
        nama: data.nama,
        kodeSatuan: data.kodeSatuan,
      }))
      resKobar.unshift({ text: '-- Pilih Salah Satu --', value: null })
      return resKobar
    }

    const getKobar2 = async (kobar = '', kolok = null) => {
      const params = {
        kib: 'A',
        cari: kobar,
        kolok,
        length: 100000,
      }
      let resKobar = await master.getKobar(g, params)

      resKobar = resKobar.rows.map(data => ({
        text: `${data.kode} :: ${data.nama}`,
        value: data.kode,
        nama: data.nama,
      }))
      resKobar.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataGedungBangunanTanahMilikKobar.value = resKobar
    }

    if (gedungBangunanTanahMilikPdUkpd.value?.value) {
      getKobar2(
        gedungBangunanTanahMilikKobar.value?.value,
        gedungBangunanTanahMilikPdUkpd.value?.value,
      )
    }

    const getKobar3 = async (kobar = '', kolok = null) => {
      const params = {
        kib: kibSeharusnya.value ? kibSeharusnya.value : props.kibVal,
        cari: kobar,
        kolok,
      }
      let resKobar = await master.getKobar(g, params)

      resKobar = resKobar.rows.map(data => ({
        text: `${data.kode} :: ${data.nama}`,
        value: data.kode,
        nama: data.nama,
      }))
      resKobar.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataIndikasiGandaKobar.value = resKobar
    }

    const getNoReg = async () => {
      const params = {
        kib: kibSeharusnya.value ? kibSeharusnya.value : props.kibVal,
        tahun_rekon: props.rekonTahunVal,
        kode_rekon: props.rekonKodeVal,
        kobar: indikasiGandaKobar.value.value,
        kolok:
          indikasiGandaPdUkpd.value ?? indikasiGandaPdUkpd.value
            ? indikasiGandaPdUkpd.value.value
            : null,
      }
      const resNoReg = await master.getNoReg(g, params)
      let tempNoreg = []
      if (resNoReg.rows) {
        tempNoreg = resNoReg.rows.map(data => ({
          text: `${data.noreg_108} :: ${data.ALAMAT}`,
          value: data.noreg_108,
        }))
      }
      tempNoreg.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataIndikasiGandaRegister.value = tempNoreg
    }

    const getNoReg2 = async () => {
      const params = {
        kib: 'A',
        tahun_rekon: props.rekonTahunVal,
        kode_rekon: props.rekonKodeVal,
        kolok: gedungBangunanTanahMilikPdUkpd.value.value,
        kobar:
          gedungBangunanTanahMilikKobar.value
          ?? gedungBangunanTanahMilikKobar.value
            ? gedungBangunanTanahMilikKobar.value.value
            : null,
      }
      let resNoReg = await master.getNoReg(g, params)
      if (resNoReg.rows) {
        resNoReg = resNoReg.rows.map(data => ({
          text: `${data.noreg_108} :: ${data.ALAMAT}`,
          value: data.noreg_108,
        }))
        resNoReg.unshift({ text: '-- Pilih Salah Satu --', value: null })
        dataGedungBangunanTanahMilikRegister.value = resNoReg
      }
    }

    const changeIndikasiGandaDengan = () => {
      if (indikasiGandaDengan.value == 3) {
        isLoadIndikasiGandaPdUkpd.value = true
        getKobar3(
          '',
          indikasiGandaPdUkpd.value ?? indikasiGandaPdUkpd.value
            ? indikasiGandaPdUkpd.value.value
            : null,
        )
        isLoadIndikasiGandaPdUkpd.value = false
      }
    }

    const handleUkuran = () => {
      if (
        (kodeBarangSeharusnya.value.kodeSatuan == 'UN'
          || kodeBarangSeharusnya.value.kodeSatuan == 'BH'
          || kodeBarangSeharusnya.value.kodeSatuan == 'EK'
          || kodeBarangSeharusnya.value.kodeSatuan == 'UN/BH'
          || kesesuaianKodeBarang.value === '1')
        && props.ukuranVal == 1
        && (satuanSeharusnya.value == 'UN'
          || satuanSeharusnya.value == 'BH'
          || satuanSeharusnya.value == 'EK'
          || satuanSeharusnya.value == 'UN/BH')
      ) {
        isDisableUkuran.value = true
        kesesuaianUkuran.value = '1'
      } else if (
        satuanSeharusnya.value == 'UN'
        || satuanSeharusnya.value == 'BH'
        || satuanSeharusnya.value == 'EK'
        || satuanSeharusnya.value == 'UN/BH'
      ) {
        kesesuaianUkuran.value = '0'
        ukuranSeharusnya.value = 1
        isDisableUkuran.value = true
      } else isDisableUkuran.value = false
    }

    const changeKesesuaianBarang = () => {
      satuanSeharusnya.value = kesesuaianKodeBarang.value === '0'
        ? kodeBarangSeharusnya.value.kodeSatuan
        : props.satuanVal

      handleUkuran()
    }

    const inputKodeBarangSeharusnya = () => {
      namaBarangSeharusnya.value = kodeBarangSeharusnya.value.nama
      satuanSeharusnya.value = kodeBarangSeharusnya.value.kodeSatuan
      handleUkuran()
    }

    const keyUpLantai = () => {
      if (isBertingkat.value === '0' && isLantaiDigunakan.value === '1') { jumlahLantaiTidakDigunakan.value = 1 }

      jumlahLantaiDigunakan.value = (
        jumlahSeluruhLantai.value - jumlahLantaiTidakDigunakan.value
      ).toString()
    }

    const searchGedungBangunanTanahMilikKobar = search => {
      getKobar2(search, gedungBangunanTanahMilikPdUkpd.value?.value)
    }

    const searchIndikasiGandaKobar = search => {
      getKobar3(search, indikasiGandaPdUkpd.value?.value)
    }

    const inputIndikasiGandaKobar = () => {
      isLoadIndikasiGandaRegister.value = true
      getNoReg()
      isLoadIndikasiGandaRegister.value = false
      indikasiGandaRegister.value = {
        text: '-- Pilih Salah Satu --',
        value: null,
      }
    }

    const inputIndikasiGandaPdUkpd = () => {
      getKobar3('', indikasiGandaPdUkpd.value?.value)
      indikasiGandaKobar.value = {
        text: '-- Pilih Salah Satu --',
        value: null,
      }
      indikasiGandaRegister.value = {
        text: '-- Pilih Salah Satu --',
        value: null,
      }
    }

    const changeBertingkatSeharusnya = () => {
      jumlahSeluruhLantai.value = bertingkatSeharusnya.value - -1
      keyUpLantai()
    }

    const inputGedungBangunanTanahMilikPdUkpd = () => {
      getKobar2(
        '',
        gedungBangunanTanahMilikPdUkpd.value
          ?? gedungBangunanTanahMilikPdUkpd.value
          ? gedungBangunanTanahMilikPdUkpd.value.value
          : null,
      )

      gedungBangunanTanahMilikKobar.value = {
        text: '-- Pilih Salah Satu --',
        value: null,
      }
      gedungBangunanTanahMilikRegister.value = {
        text: '-- Pilih Salah Satu --',
        value: null,
      }
    }

    const inputGedungBangunanTanahMilikKobar = () => {
      getNoReg2()
    }

    const changeIsBertingkat = () => {
      jumlahSeluruhLantai.value = isBertingkat.value === '0' ? 1 : bertingkatSeharusnya.value - -1
      keyUpLantai()
    }

    const validateState = item => {
      const { $error } = item
      let result = null
      if ($error) result = false
      return result
    }

    const changeIntOnly = evt => {
      setInputIntOnly(evt)
    }

    const resetForm = () => {}

    const validateState2 = item => {
      const { $error } = item
      return $error ? false : null
    }

    getTingkat()
    getNoReg()
    getNoReg2()

    return {
      v$,
      $externalResults,
      isSubmit,
      isShowInfo,
      isShowData,
      defaultKolok,
      // variable string, int
      kesesuaianKodeBarang,
      kibSeharusnya,
      satuanSeharusnya,
      isDisableUkuran,
      kodeBarangSeharusnya,
      namaBarangSeharusnya,
      kesesuaianUkuran,
      ukuranSeharusnya,
      namaSpesifikasiBarang,
      isBertingkat,
      bertingkatSeharusnya,
      isLantaiDigunakan,
      jumlahSeluruhLantai,
      jumlahLantaiDigunakan,
      jumlahLantaiTidakDigunakan,
      kesesuaianBahan,
      bahanSeharusnya,
      skPenggunaan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      penggunaan,
      digunakanUntuk,
      pdUkpd,
      pemanfaat,
      gedungBangunanTanahMilik,
      isGedungBangunanTanahMilikTercatat,
      gedungBangunanTanahMilikSebutkan,
      kesesuaianAlamat,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      isIndikasiGanda,
      indikasiGandaDengan,
      isLoadIndikasiGandaPdUkpd,
      indikasiGandaSebutkan,
      indikasiGandaPdUkpd,
      indikasiGandaKobar,
      indikasiGandaRegister,
      isLoadIndikasiGandaRegister,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikKeterangan,
      indikasiGabungan,
      indikasiGabunganKeterangan,
      isAtapBeton,
      isAtapBetonIsDigunakan,
      atapBetonDigunakan,
      isBasement,
      isBasementIsDigunakan,
      basementDigunakan,
      isHalamanUtama,
      isHalamanUtamaIsDigunakan,
      halamanUtamaDigunakan,
      nilaiStrategisBMD,
      memilikiNilaiStrategis,
      pengamananFisik,
      fisikDikuasai,
      fisikDikuasaiSebutkan,
      fisikTidakDikuasaiSebutkan,
      sengketaGedungBangunan,
      ketAsetBersejarah,
      // variable array
      getKobarTemp,
      dataKobar,
      dataIndikasiGandaKobar,
      dataBertingkatSeharusnya,
      dataBahanSeharusnya,
      dataPenggunaan,
      dataPdUkpd,
      dataPemanfaat,
      dataIndikasiGandaDengan,
      dataIndikasiGandaPdUkpd,
      dataIndikasiGandaRegister,
      dataGedungBangunanTanahMilikRegister,
      dataGedungBangunanTanahMilikKobar,
      dataIndikasiGabungan,
      dataNilaiStrategisBMD,
      // variable func
      resetForm,
      validateState,
      submitForm,
      changeIntOnly,
      changeIndikasiGandaDengan,
      changeKesesuaianBarang,
      inputKodeBarangSeharusnya,
      keyUpLantai,
      inputIndikasiGandaKobar,
      searchIndikasiGandaKobar,
      searchGedungBangunanTanahMilikKobar,
      validateState2,
      changeBertingkatSeharusnya,
      digunakanBersama,
      inputGedungBangunanTanahMilikPdUkpd,
      inputGedungBangunanTanahMilikKobar,
      inputIndikasiGandaPdUkpd,
      changeIsBertingkat,
      handleUkuran,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    V1KodeBarang,
    V2Ukuran,
    V3SpesifikasiBarang,
    V4Alamat,
    V5GedungBangunanDiatasTanahMilik,
    V6IndikasiTercatatGanda,
    V7IndikasiTercatatGabungan,
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BRow,
  },
  props: {
    kolokVal: { type: String, default: '' },
    kibVal: { type: String, default: '' },
    kobarVal: { type: String, default: '' },
    nabarVal: { type: String, default: '' },
    kodeRegisterBarangVal: { type: String, default: '' },
    nilaiPerolehanVal: { type: String, default: '' },
    tahunPerolehanVal: { type: String, default: '' },
    ukuranVal: { type: String, default: '' },
    jenisBetonVal: { type: String, default: '' },
    alamatVal: { type: String, default: '' },
    rekonKodeVal: { type: String, default: '' },
    rekonTahunVal: { type: String, default: '' },
    satuanVal: { type: String, default: '' },

    kesesuaianKodeBarangVal: { type: String, default: '' },
    satuanSeharusnyaVal: { type: String, default: '' },
    kibSeharusnyaVal: { type: String, default: '' },
    namaBarangSeharusnyaVal: { type: String, default: '' },
    kodeBarangSeharusnyaVal: {
      type: Object,
      default: () => ({}),
    },
    kesesuaianUkuranVal: { type: String, default: '' },
    ukuranSeharusnyaVal: { type: String, default: '' },
    namaSpesifikasiBarangVal: { type: String, default: '' },
    isBertingkatVal: { type: String, default: '' },
    bertingkatSeharusnyaVal: { type: String, default: '' },
    jumlahSeluruhLantaiVal: { type: String, default: '' },
    isLantaiDigunakanVal: { type: String, default: '' },
    jumlahLantaiTidakDigunakanVal: { type: String, default: '' },
    jumlahLantaiDigunakanVal: { type: String, default: '' },
    kesesuaianBahanVal: { type: String, default: '' },
    bahanSeharusnyaVal: { type: String, default: '' },
    skPenggunaanVal: { type: String, default: '' },
    nomorSkPenggunaanVal: { type: String, default: '' },
    tahunSkPenggunaanVal: { type: String, default: '' },
    penggunaanVal: { type: String, default: '' },
    digunakanBersamaVal: { type: Array, default: () => ([]) },
    digunakanUntukVal: { type: Array, default: () => ([]) },
    pdUkpdVal: { type: Array, default: () => ([]) },
    pemanfaatVal: { type: Array, default: () => ([]) },
    gedungBangunanTanahMilikVal: { type: String, default: '' },
    isGedungBangunanTanahMilikTercatatVal: { type: String, default: '' },
    gedungBangunanTanahMilikPdUkpdVal: {
      type: Object,
      default: () => ({}),
    },
    gedungBangunanTanahMilikKobarVal: {
      type: Object,
      default: () => ({}),
    },
    gedungBangunanTanahMilikRegisterVal: {
      type: Object,
      default: () => ({}),
    },
    gedungBangunanTanahMilikKeteranganVal: { type: String, default: '' },
    gedungBangunanTanahMilikSebutkanVal: { type: String, default: '' },
    provinsiVal: { type: String, default: '' },
    kabKotaVal: { type: String, default: '' },
    kecamatanVal: { type: String, default: '' },
    kelurahanVal: { type: String, default: '' },
    jalanVal: { type: String, default: '' },
    noAlamatVal: { type: String, default: '' },
    rtVal: { type: String, default: '' },
    rwVal: { type: String, default: '' },
    kodePosVal: { type: String, default: '' },
    isIndikasiGandaVal: { type: String, default: '' },
    indikasiGandaDenganVal: { type: String, default: '' },
    indikasiGandaSebutkanVal: { type: String, default: '' },
    indikasiGandaPdUkpdVal: { type: Object, default: () => ({}) },
    indikasiGandaKobarVal: { type: Object, default: () => ({}) },
    indikasiGandaRegisterVal: { type: Object, default: () => ({}) },
    indikasiGabunganVal: { type: String, default: '' },
    isAtapBetonVal: { type: String, default: '' },
    isAtapBetonIsDigunakanVal: { type: String, default: '' },
    atapBetonDigunakanVal: { type: String, default: '' },
    isBasementVal: { type: String, default: '' },
    isBasementIsDigunakanVal: { type: String, default: '' },
    basementDigunakanVal: { type: String, default: '' },
    isHalamanUtamaVal: { type: String, default: '' },
    isHalamanUtamaIsDigunakanVal: { type: String, default: '' },
    halamanUtamaDigunakanVal: { type: String, default: '' },
    nilaiStrategisBMDVal: { type: String, default: '' },
    memilikiNilaiStrategisVal: { type: Array, default: () => ([]) },
    pengamananFisikVal: { type: String, default: '' },
    fisikDikuasaiVal: { type: String, default: '' },
    fisikDikuasaiSebutkanVal: { type: String, default: '' },
    fisikTidakDikuasaiSebutkanVal: { type: String, default: '' },
    sengketaGedungBangunanVal: { type: String, default: '' },
    statusPersetujuanVal: { type: String, default: '' },
    catatanVal: { type: String, default: '' },
    ketAsetBersejarahVal: { type: String, default: '' },

    isShowUbahVal: Boolean,

    title: { type: String, default: '' },
    id: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
